/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { MailControllerApi, PortesControllerApi, settings, UsersControllerApi, NavisionControllerApi, ClientesControllerApi, ConexionSatControllerApi, VendedorControllerApi, MultiempresasControllerApi, PaisesControllerApi, ProvinciasControllerApi, FiltrosPantallasControllerApi } from '@api/backend'
import instance from '@api/pim'
import { odataLogs, displayErrorMsg, displayInfoMsg, displaySuccessMsg, getUserData, testJSON, devuelveBasePath, devuelveBasePathPim, eliminaRepetidos, modeloProductoParaRepuesto, getPrecioTotalconDescuento, getCodVendedor } from '@utils'
import axios from 'axios'
import Swal from 'sweetalert2'
const prefix = 'ecommerce'

const apiUser = new UsersControllerApi(settings)
const apiMail = new MailControllerApi(settings)
const apiPortes = new PortesControllerApi(settings)
const config = settings
const apiNavisionNew = new NavisionControllerApi(settings)
const clienteasApi = new ClientesControllerApi(settings)
const apiSat = new ConexionSatControllerApi(settings)
const vendedorApi = new VendedorControllerApi(settings)
const multiempresasApi = new MultiempresasControllerApi(settings)
const apiPaises = new PaisesControllerApi(settings)
const apiProvincias = new ProvinciasControllerApi(settings)
const apiFiltrosPantallas = new FiltrosPantallasControllerApi(settings)

export const SEND_DELIVERY_NOTE = `${prefix}/SEND_DELIVERY_NOTE`
export const GET_PRODUCTS_PAG = `${prefix}/GET_PRODUCTS_PAG`

export const obtenerFiltrosPantalla = async (idUsuario, nombrePantalla) => {
  try {
    const filter = {
      where: {
        and: [
          { usuarioId: idUsuario },
          { pantalla: nombrePantalla }
        ]
      }
    };
    
    const response = await apiFiltrosPantallas.filtrosPantallasControllerFind(JSON.stringify(filter));
    if (response.data.length > 0) {
      const filtros = JSON.parse(response.data[0].filtros);
      console.log("Filtros obtenidos:", filtros);
      return filtros;
    } else {
      console.log("No se encontraron filtros para el usuario y pantalla especificados.");
      return null;
    }
  } catch (err) {
    console.error("Error al obtener filtros de pantalla:", err.message);
    return null;
  }
};

export const actualizarFiltrosPantalla = async (idUsuario, nombrePantalla, filtro) => {
  try {
    console.log("Actualizando filtros de pantalla...", filtro);
    const filter = {
      where: {
        and: [
          { usuarioId: idUsuario },
          { pantalla: nombrePantalla }
        ]
      }
    };

    const response = await apiFiltrosPantallas.filtrosPantallasControllerFind(JSON.stringify(filter));
    if (response.data.length === 0) {
      // No existe, crear nuevo registro
      const nuevoRegistro = {
        usuarioId: idUsuario,
        pantalla: nombrePantalla,
        filtros: filtro
      };
      const createResponse = await apiFiltrosPantallas.filtrosPantallasControllerCreate(nuevoRegistro);
      return createResponse.data;
    } else {
      // Existe, actualizar registro
      const idRegistro = response.data[0].id;
      const updateResponse = await apiFiltrosPantallas.filtrosPantallasControllerUpdateById(idRegistro, { filtros: filtro });
      return updateResponse.data;
    }
  } catch (err) {
    console.error("Error al actualizar filtros de pantalla:", err.message);
    return null;
  }
};

const armarFiltroCarrito = async (cart) => {
  if (!Array.isArray(cart)) {
    console.error('El carrito proporcionado no es válido');
    return;
  }

  const filtroCarrito = cart.map(item => ({
    idProducto: item.id,
    sku: item.sku,
    cantidad: item.qty,
    descuento: item.CustomerSalesDiscount || item.porcentajeDescuento || '0'
  }));

  try {
    const { id } = getUserData()
    const jsonString = JSON.stringify(filtroCarrito);
    const respuesta = await actualizarFiltrosPantalla(id, 'carrito', jsonString)
    console.log('Respuesta de la API:', respuesta);
  } catch (error) {
    console.error('Error al guardar el filtro de el carrito:', error);
  }
};

//O B T I E N E - S I T U A C I O N E S - A P I - (P I M)
export const getSituaciones = () => {
  return async () => {
      const { data: SituacionesPim } = await instance().get(`/Situaciones`)
      const arraySituaciones = SituacionesPim.map(situacion => ({
          value: situacion.id,
          label: situacion.nombre
      }));
      const etiquetasPermitidas = ['ACTIVA', 'FIN EXISTENCIAS', 'PROXIMAMENTE', 'DESCATALOGADA'];
      const arraySituacionesFiltrado = arraySituaciones.filter(
        situacion => etiquetasPermitidas.includes(situacion.label)
      );      
      return arraySituacionesFiltrado
  }
}

export const getPortes = () => {
  return async () => {
    try {
      const {data: dataPortes} = await apiNavisionNew.navisionControllerGetendPoint('shippingCosts')
      await apiPortes.portesControllerFind().then(resp => {
        resp.data.forEach(async el => {
          await apiPortes.portesControllerDeleteById(el.id)
        })
        dataPortes.value.forEach(async el => {
          await apiPortes.portesControllerCreate(JSON.stringify(el))
        })
      })
      
    } catch (err) {
      console.error(err.message)
    }
  }
}

export const getPrecioPortes = () => {
  return async (dispatch) => {
    try {
      const {data: dataPortes} = await apiPortes.portesControllerFind()
      const {data: dataProvincias} = await apiProvincias.provinciasControllerFind()
      const {data: dataPaises} = await apiPaises.paisesControllerFind()
      dispatch({
        type: `${prefix}/GET_PORTES`,
        data: dataPortes,
        prov: dataProvincias,
        pais: dataPaises
      })
    } catch (err) {
      console.error(err)
    }
  }
}


//O B T I E N E - P A I S E S
export const getPaises = () => {
  return async () => {
      const {data: dataPaises} = await apiPaises.paisesControllerFind()
      const arrayPaises = dataPaises.map(objPais => ({
          value: objPais.codigo,
          label: `${objPais.pais}`,
          id: objPais.id
      }));
      return arrayPaises
  }
}

//O B T I E N E - P R O V I N C I A S
export const getProvincias = () => {
  return async () => {
      const {data: dataProvincias} = await apiProvincias.provinciasControllerFind()
      const arrayProvincias = dataProvincias.map(objProvincia => ({
          value: objProvincia.codigo,
          label: `${objProvincia.provincia}`,
          paisId: objProvincia.paisId
      }));
      return arrayProvincias
  }
}

// ** Get Query Customer
export const getCustomerAddresses = (cliente, shop = true) => {
  return async (dispatch) => {
    try {
      const cod = getUserData()
      let filter = {where: {
        ['customerNo']:`${cliente.split(' ')[0]}`,
        ['shop']: shop
        }
      }
      if (cod.companyId !== 43) {
        filter = {where: {
          ['customerNo']:`${cliente.split(' ')[0]}`,
          ['shop']: shop,
          ['companyId'] : cod.companyId
          }
        }
      }
      await clienteasApi.clientesControllerFind(JSON.stringify(filter)).then((response) => {
        const { data } = response
        dispatch({
          type: `${prefix}/GET_CUSTOMER_ADDRESSES`,
          data
        })
      }).catch((err) => console.error(err.message))
    } catch (err) {
      console.error(err.message)
    }
  }
}

// ** SET direccion de envio
export const setShippingAddress = (data) => {
  return async (dispatch) => {
    dispatch({ type: `${prefix}/NEW_ADRESS_ACTIVE`, data: false })
    return dispatch({ type: `${prefix}/SET_SHIPPING_ADDRESS`, data })
  }
}

export const setNumeroRandom = (data) => {
  return async (dispatch) => {
    // dispatch({ type: `${prefix}/NUMERO_RANDOM`, data: numeroRandom })
    return dispatch({ type: `${prefix}/NUMERO_RANDOM`, data})
  }
}

// Función para crear un cliente en la tabla CLIENTES
// Esto sirve para no tener que esperar a que se sincronice por la noche la tabla clientes, cuando se crea una nueva direccion. 
const crearElNuevoClienteEnLaBD = async (cliente) => {
  try {
    const cod = getUserData()

    cliente.companyId = cod.companyId

    // Elimina propiedades innecesarias
    delete cliente.customerType;
    delete cliente.addressType;
    delete cliente.customerFilter_FilterOnly;

    let partes01 = '';
    let partes02 = '';
    const resultado = [];

    // Verificar y procesar itemFilter01
    if (cliente.itemFilter01 !== '' && cliente.itemFilter01 !== '###') {
      partes01 = cliente.itemFilter01.split('#');
    }

    // Verificar y procesar itemFilter02
    if (cliente.itemFilter02 !== '' && cliente.itemFilter02 !== '###') {
      partes02 = cliente.itemFilter02.split('#');
    }

    // Proceso de combinación de filtros
    if (partes01 && partes02) {
      for (let i = 0; i < partes01.length; i++) {
        const parte1 = partes01[i].split('|');
        const parte2 = partes02[i].split('|');
        if (JSON.stringify(parte1) === JSON.stringify(parte2)) {
          resultado.push(parte1.join('|'));
        } else {
          resultado.push(parte1.concat(parte2).join('|'));
        }
      }
      cliente.markFilter = resultado[1];
      cliente.filtercategories = resultado[2];
      cliente.referenceStatus = resultado[3];
    } else if (partes01) {
      cliente.markFilter = partes01[1];
      cliente.filtercategories = partes01[2];
      cliente.referenceStatus = partes01[3];
    } else if (partes02) {
      cliente.markFilter = partes02[1];
      cliente.filtercategories = partes02[2];
      cliente.referenceStatus = partes02[3];
    } else {
      cliente.markFilter = '';
      cliente.filtercategories = '';
      cliente.referenceStatus = '';
    }

    // convertimos a string estos datos
    cliente.shop = cliente.shop.toString();
    cliente.allowStock = cliente.allowStock.toString();
    cliente.shippingIncluded = cliente.shippingIncluded.toString();

    const objClienteCreado = await clienteasApi.clientesControllerCreate(cliente);
    return objClienteCreado.data.id;
  } catch (error) {
    console.error('Error al insertar cliente: ', error);
    displayErrorMsg('Error al crear el registro en la tabla clientes');
  }
};

// Función auxiliar compartida para llamar al endpoint de Navision
const llamadaBCEndpoint = async (addressData) => {
  const objJSON = JSON.stringify(addressData)
  const { data } = await apiNavisionNew.navisionControllerPostEndpointBC("TW_Functions_InsertShipToCode", objJSON)
  
  if (data.mensaje.message) {
    throw new Error(data.mensaje.message)
  }
  
  return data
}

// Función auxiliar compartida para procesar múltiples empresas
const procesarMultiplesEmpresas = async (shippingAddress, arrayEmpresas, processingCallback) => {
  let lastResult
  
  for (const empresa of arrayEmpresas) {
    const shippingAddressWithCompany = {
      ...shippingAddress,
      pEmpresa: empresa
    };
    const result = await processingCallback(shippingAddressWithCompany)
    lastResult = result
    console.log(`Procesado para empresa ${empresa}:`, result);
  }
  
  return lastResult
}

// Función auxiliar para el flujo principal de direcciones
const procesarDireccionNuevaOEditar = async (shippingAddress, processingCallback, dispatch, intl, isEdit = false) => {
  try {
    const actionMessage = isEdit ? "Editing address" : "New address being created"
    const successMessage = isEdit ? "Correctly edited address" : "New address successfully created"
    
    displayInfoMsg(intl.formatMessage({ id: actionMessage }))
    const cod = getUserData()
    let lastResult
    
    if (cod.companyId === 43) {
      const arrayEmpresas = ['SVAN', 'KOREAN']
      lastResult = await procesarMultiplesEmpresas(shippingAddress, arrayEmpresas, processingCallback)
    } else {
      lastResult = await processingCallback(shippingAddress)
    }
    
    displaySuccessMsg(intl.formatMessage({ id: successMessage }))
    
    if (lastResult) {
      dispatch({ type: `${prefix}/NEW_SHIPPING_ADDRESS`, data: lastResult })
    }
    
  } catch (error) {
    displayErrorMsg(error.message || error)
  }
}

// ** Crear nueva dirección
export const createNewShippingAddress = (shippingAddress, intl) => {
  return async (dispatch, getState) => {
    const processNewAddress = async (addressData) => {
      const data = await llamadaBCEndpoint(addressData)
      
      let idNuevoRegistro
      
      if (data.mensaje.includes('shipToCode')) {
        const shipToCode = JSON.parse(data.mensaje).Resultado[0].shipToCode
        const filtro = `customerNo eq '${shippingAddress.sellToCustomerNo}' and shipToCode eq '${shipToCode}'`

        await apiNavisionNew.navisionControllerGetendPoint('queryCustomer', filtro, 100000, 0, '', '', true).then(async (response) => {
          if (response.data?.mensaje?.message) {
            throw new Error(response.data.mensaje.message)
          }
          const { data: responseData } = response
          if (responseData && responseData.value.length > 0) {
            const cliente = responseData.value[0];
            idNuevoRegistro = await crearElNuevoClienteEnLaBD(cliente);
            await dispatch(getCustomerAddresses(cliente.customerNo, false))
          }
        }).catch((err) => {
          throw new Error(err.message)
        })
      }
      
      if (idNuevoRegistro) {
        dispatch({ type: `${prefix}/ID_REGISTRO_NUEVA_DIRECCION_CLIENTE`, data: idNuevoRegistro })
      }
      
      return JSON.parse(data.mensaje).Resultado[0].shipToCode
    }
    
    await procesarDireccionNuevaOEditar(shippingAddress, processNewAddress, dispatch, intl, false)
  }
}

// ** Editar dirección
export const editarDireccion = (shippingAddress, idRegistroDireccionCliente, intl) => {
  return async (dispatch, getState) => {
    const processEditAddress = async (addressData) => {
      const data = await llamadaBCEndpoint(addressData)

      const nuevosDatosCliente = {
        name: addressData.shipToName.toString(),
        address: addressData.shipToAddress.toString(),
        city: addressData.shipToCity.toString(),
        postCode: addressData.shipToPostCode.toString(),
        country: addressData.shipToCountry.toString(),
        contact: addressData.shipToContact.toString(),
        phoneNo: addressData.shipToPhone.toString(),
        eMail: addressData.shipToEmail.toString()
      }

      const objClienteActualizado = await clienteasApi.clientesControllerUpdateById(idRegistroDireccionCliente, nuevosDatosCliente);
      console.log('objClienteActualizado:', objClienteActualizado);

      await dispatch(getCustomerAddresses(addressData.sellToCustomerNo, false))
      
      return JSON.parse(data.mensaje).Resultado[0].shipToCode
    }
    
    await procesarDireccionNuevaOEditar(shippingAddress, processEditAddress, dispatch, intl, true)
  }
}

// ** GET Categorias y familias del PIM
export const getFilters = () => {
  return async (dispatch) => {
    instance().get('/categorias').then(response => {
      // Los labels vienen en formato json, los parseamos para poder utilizarlos luego
      response.data = response.data.map(cat => {
        // Si no tiene label asignados vienen con array vacio, y hay algunas que hacen
        // porque tienen dos "" para cerrar por ejemplo y son json inválido
        const nombre = testJSON(cat.nombre) ? JSON.parse(cat.nombre) : cat.nombre
        return { ...cat, nombre }
      })
      let categories = response.data.filter(cat => (cat.padre === "" || cat.padre === cat.codigo || cat.padre === 'master') && cat.codigo !== "master")
      let mainChilds, subCats
      categories.forEach(mainCat => {
        mainChilds = []
        subCats = response.data.filter(cat => cat.padre === mainCat.codigo)
        subCats.forEach(subCat => {
          mainChilds.push(subCat.codigo)
          const subCats2 = response.data.filter(cat => cat.padre === subCat.codigo)
          mainChilds = [...mainChilds, ...subCats2.map(cat => cat.codigo)]
          const subChilds = subCats2.map(cat => cat.codigo)
          subCats = subCats.map(cat => (cat.codigo === subCat.codigo ? { ...cat, subs: subCats2, childs: subChilds } : cat))
        })
        categories = categories.map(cat => (cat.codigo === mainCat.codigo ? { ...cat, subs: subCats, childs: mainChilds } : cat))
      })
      dispatch({ type: `${prefix}/SET_CATEGORIES`, categories })
    })
  }
}

// ** GET Atributos del PIM y data relacionada necesaria
export const getAtributos = () => {
  return async (dispatch) => {
    const { data } = await instance().get('/atributos')
    //
    //Recupera los datos de Mysql
    //
    const atributos = {}
    //
    //Bucle para montar la información que necesitamos en la Ficha Técnica
    //
    data.forEach(att => {
      //
      //Busca en los nombre de los atributos de Nav el atributo actual
      //
      //Añade un registro al array "atributos"
      //
      //Compruebo el tipo de campo que para poder devolver el valor correcto
      let tipoCampo = "";
      if (att.tipoCampo.toLowerCase() == "o") {
        tipoCampo = "Option"
      } else 
      if (att.tipoCampo.toLowerCase() == "t") {
        tipoCampo = "Text"
      } else if (att.tipoCampo.toLowerCase() == "n") {
        tipoCampo = "Num"
      }

      atributos[att.id] = {
        id: att.id,
        label: att.nombre,
        group: (att.tipo === 'file') ? 'adjuntos' : 'Producto',
        code: att.codigo,
        type: tipoCampo,
        principalFilter: true,
        values: att.posiblesValores.split(','),
        categorias: att.categorias
      }
    })
    //
    //Devuelve la información
    //
    dispatch({ type: `${prefix}/SET_ATRIBUTOS`, atributos })
  }
}

const getMarcas = async () => {
  //
  //Función que devuelve las marcas del PIM que son visibles en B2B
  //
  try {   
    const { data: codMarcas } = await instance().get('/Marca', {
      params: {
        filter: JSON.stringify({
          where: { visibleb2b: "S" },
          fields: {
            id: true,
            nombre: true,
            codigo: true,
            color: true,
            web: true,
            visibleb2b: true,
            sincronizarEstadoReferencia: true
          }
        })
      }
    });
    if (codMarcas) {
      // Transforma los datos al formato deseado
      const codMarcasArregladas = codMarcas.map(marca => ({
        cod: marca.codigo.toUpperCase(),
        nombre: marca.nombre.toUpperCase()
      }));
      return codMarcasArregladas;
    }
  } catch (error) {
    console.error('Error al obtener las marcas:', error);
  } 
}

const getCodigoMarca = async(marca) => {
  //
  //Obtenemos las mardcas del PIM visibles en B2B
  //
  const codMarcas = await getMarcas();
  //
  //Filtramos y devolvemos el valor
  //
  const codigo = codMarcas.find(el => el.nombre.toLowerCase() == marca.toLowerCase())
  return codigo?.cod
}

const getNombreMarca = async(marca) => {
  //
  //Obtenemos las mardcas del PIM visibles en B2B
  //
  const codMarcas = await getMarcas();
  //
  //Filtramos y devolvemos el valor
  //
  const nombre = codMarcas.find(el => el.cod.toLowerCase() == marca.toLowerCase())
  return nombre?.nombre
}

async function fetchCompaniesForProducts(products, clientes) {
  try {
      // Iterar sobre el array de productos
      const promises = products.map(async (product) => {
          const categoria = product.itemCategoryParent || product.category;
          // Llamar a multiempresasControllerSearchCompanies para cada producto
          const response = await multiempresasApi.multiempresasControllerSearchCompanies(
              await getCodigoMarca(product.brand),
              categoria || '',
              product.categoria_padre || '',
              clientes
          );
          // Manejar la respuesta
          const companyData = response.data[0]; // Asumiendo que la respuesta es un array con un objeto
          return { product, companyData };
      });

      // Esperar a que todas las promesas se resuelvan
      const allCompaniesData = await Promise.all(promises);

      // Agrupar los productos por compañía
      const groupedByCompany = allCompaniesData.reduce((acc, { product, companyData }) => {
          const companyName = companyData.company; // Acceder correctamente al nombre de la compañía
          if (!acc[companyName]) {
              acc[companyName] = [];
          }
          acc[companyName].push(product);
          return acc;
      }, {});

      return groupedByCompany;
  } catch (error) {
      // Manejar los errores
      console.error('Error fetching companies for products:', error);
      throw error;
  }
}

// ** GET Products
export const getProducts = (params) => {
  return async (dispatch, getState) => {
    const { perPage, page, sortBy, q, code } = params
    let { tarifa } = params
    const allProducts = getState().ecommerce.allProducts
    let productosNav = []
    const storeAdmin = await getState().admin

    if (sortBy) {
      //
      //Ordenamos alfabéticamente 
      //
      if (sortBy === 'alfabeticamente') {
        allProducts.sort((a, b) => {
          const nameA = a.sku.toUpperCase(); // Convertir a mayúsculas para ordenar insensible a mayúsculas/minúsculas
          const nameB = b.sku.toUpperCase(); // Convertir a mayúsculas para ordenar insensible a mayúsculas/minúsculas
        
          if (nameA < nameB) {
            return -1; // a debe venir antes que b en el orden
          }
          if (nameA > nameB) {
            return 1; // b debe venir antes que a en el orden
          }
          return 0; // son iguales, no se cambia el orden
        })
      }
      //
      //Ordenamos por fecha
      //
      if (sortBy === 'fechaCreacion') {
        //
        //Anters de ordenar tratamos la fecha para que solo lleve año, mes y día y tenga el formato que necesita JS (YYY-MM-DD) para realizar bien la ordenación
        //
        allProducts.forEach((product) => {
          const fechaStr = product.fecha_creacion_producto;
          const partesFecha = fechaStr.split(' ');
          const partesFechaYMD = partesFecha[0].split('/');
          product.fecha_creacion_producto_cortada = `${partesFechaYMD[2]}-${partesFechaYMD[1]}-${partesFechaYMD[0]}`
        });
        allProducts.sort((a, b) => {
          const fechaA = new Date(a.fecha_creacion_producto_cortada);
          const fechaB = new Date(b.fecha_creacion_producto_cortada);
          return fechaB - fechaA;
        });
      }
    }

    const productosPaginados = allProducts.slice(((page || 1) * (perPage || 9)) - (perPage || 9), (page || 1) * (perPage || 9))
    console.log('Productos paginados - Antes de obtener el Stock con BC:', productosPaginados);
    const products = productosPaginados.map(product => {
      return { ...product, obteniendoStock: true }
    })

    if (products.length > 0) {
      if (storeAdmin.users.selectedUser.tipoUsuario != "V" && storeAdmin.users.selectedUser.tipoUsuario != "Vendedor") {
        tarifa = ''
      }
      if (storeAdmin.users.selectedUser.companyId !== 43) {
        const listaSlugs = products.map(item => item.slug);
        const arraySlugs = listaSlugs.join("|")
        const encodedSlugs = encodeURIComponent(arraySlugs); // Codifica los slugs para la URL
        await axios.get(`${devuelveBasePath()}/query-page-products/${localStorage.getItem('clienteDefecto').split(' ')[0]}/${encodedSlugs}/?customerPriceGroup=${tarifa}`).then(response => {
          console.log('Respuesta de la consulta de stock:', response);
          if (response.data.result && response.data.result.return_value != undefined) {
            productosNav = JSON.parse(response.data.result.return_value).Items
          }
        }).catch(error => {
          console.error('Error Obteniendo los Stock:', error);
        });  
        if (productosNav) {
          console.log('Productos devueltos por BC:', productosNav);
          products.forEach((product) => {
            const datoPrecios = productosNav.find(dato => dato.Model === product.slug);
            product.stock = datoPrecios?.InventoryAvailable ? datoPrecios?.InventoryAvailable : '0'
            product.precioPVR = datoPrecios?.PVRSalesPrice ? datoPrecios?.PVRSalesPrice : '0'
            product.precioPVC = datoPrecios?.CustomerSalesPrice ? datoPrecios?.CustomerSalesPrice : '0'
            product.obteniendoStock = false
          });
          localStorage.setItem('cargandoPantalla', 'NO')
          console.log('Productos paginados - Despues de obtener el Stock con BC:', products);
        }
      } else {
        let listaSlugs = []
        let companies = [];
        const results = [];
        await fetchCompaniesForProducts(products, localStorage.getItem('clienteDefecto').split(' ')[0]).then(allCompaniesData => {
          companies = Object.keys(allCompaniesData);
          companies.forEach((element, index) => {
            console.log('Elemento:', element);
            listaSlugs = allCompaniesData[element].map(item => item.slug);
            results.push({
              [element]: listaSlugs
            });
          });
        }).catch(error => {
          console.error('Error en la llamada a fetchCompaniesForProducts:', error);
        });    
        const requests = results.map(async(element, index) => {
          const encodedSlugs = encodeURIComponent(element[companies[index]].join("|")); // Codifica los slugs para la URL
          return axios.get(`${devuelveBasePath()}/query-page-products-empresa/${localStorage.getItem('clienteDefecto').split(' ')[0]}/${encodedSlugs}/${companies[index]}/?customerPriceGroup=${tarifa}`)
            .then(response => {
              if (response.data.result && response.data.result.return_value != undefined) {
                return JSON.parse(response.data.result.return_value).Items;
              }
              return [];
            })
            .catch(error => {
              console.error('Error en la llamada a axios.get:', error);
              return [];
            });
        });
        
        productosNav = await Promise.all(requests);
        // Aplana el array de arrays
        const productosNavAplanados = productosNav.flat();

        if (productosNavAplanados) {
          console.log('Productos devueltos por BC:', productosNavAplanados);
          products.forEach((product) => {
            const datoPrecios = productosNavAplanados.find(dato => dato.Model === product.slug);
            product.stock = datoPrecios?.InventoryAvailable ? datoPrecios?.InventoryAvailable : '0'
            product.precioPVR = datoPrecios?.PVRSalesPrice ? datoPrecios?.PVRSalesPrice : '0'
            product.precioPVC = datoPrecios?.CustomerSalesPrice ? datoPrecios?.CustomerSalesPrice : '0'
            product.obteniendoStock = false
          });
          localStorage.setItem('cargandoPantalla', 'NO')
          console.log('Productos paginados - Despues de obtener el Stock con BC:', products);
        }
      }
    }
    return dispatch({ type: `${prefix}/GET_PRODUCTS`, products, allProducts, params })
  }
}

export const getProductoNav = (cliente, producto, tarifa, verSoloRepuestos = false) => {
  return async (dispatch, getState) => {
    try {
      const storeAdmin = await getState().admin
      if (tarifa == undefined || tarifa ==  "") { tarifa = "" }
      let productoParsed, productoCompleto
      const {data: productosPim } = await instance().get(`/B2bProductos/${producto}`)
      productosPim[0].imagen = `${devuelveBasePathPim()}/${productosPim[0].imagen}`
      if (storeAdmin.users.selectedUser.companyId !== 43) {
        const {data: productoNav } = await axios.get(`${devuelveBasePath()}/query-page-products/${cliente}/${producto}/?customerPriceGroup=${tarifa}`)
        if (productoNav?.result?.return_value !== undefined && productoNav?.result?.return_value !== "") {
          if (verSoloRepuestos) {
            productosPim[0].soloVerRepuestos = true
          }
          productoParsed = JSON.parse(productoNav.result.return_value)
          //para los que son normales que buscan el producto en su empresa sin ser multiempresas tiene que mostrar el stock entrante como antes
          productoParsed.Items[0].verStockEntrante = true
          productosPim[0].obteniendoStock = false
          productoCompleto = {...productoParsed.Items[0], ...productosPim[0]}
        } else {
          productosPim[0].soloVerRepuestos = true
          productosPim[0].obteniendoStock = false
          productoCompleto = {...productosPim[0]}
        }
        dispatch({ 
          type: `${prefix}/GET_PRODUCT`, 
          data: productoCompleto
        })
      } else {
        let companies = [];
        let listaSlugs = [];
        const results = [];
        await fetchCompaniesForProducts(productosPim, localStorage.getItem('clienteDefecto').split(' ')[0]).then(allCompaniesData => {
          companies = Object.keys(allCompaniesData);
          companies.forEach((element, index) => {
            console.log('Elemento:', element);
            listaSlugs = allCompaniesData[element].map(item => item.slug);
            results.push({
              [element]: listaSlugs
            });
          });
        }).catch(error => {
          console.error('Error en la llamada a fetchCompaniesForProducts:', error);
        }); 
        const { data: productoNav } = await axios.get(`${devuelveBasePath()}/query-page-products-empresa/${cliente}/${listaSlugs[0]}/${companies[0]}/?customerPriceGroup=${tarifa}`)
        if (productoNav.result.return_value != undefined) {
          if (verSoloRepuestos) {
            productosPim[0].soloVerRepuestos = true
          }
          productosPim[0].obteniendoStock = false
          productoParsed = JSON.parse(productoNav.result.return_value)
          if (companies[0] !== 'SVAN TRADING S.L.') {
            //todas aquellas empresas que no sea SVAN TRADING S.L. no tienen que mostrar este apartado 
            productoParsed.Items[0].verStockEntrante = false
          } else {
            productoParsed.Items[0].verStockEntrante = true
          }
          productoCompleto = {...productoParsed.Items[0], ...productosPim[0]}
        } 
        dispatch({ 
          type: `${prefix}/GET_PRODUCT`, 
          data: productoCompleto
        })
      }
    } catch (err) {
      console.error(err)
    }
  }
}

export const getDatosNavProductos = (productos, code, tarifa) => {
  return async (dispatch, getState) => {
    try {
      let productosNav = []
      //
      //Si la tarifa no está definida le pasamos *
      //
      if (tarifa == undefined || tarifa ==  "") { tarifa = "" }
      //
      //Como son 9 productos los agrupamos consecutivamente y los pasamos de una a query-page-products (que al final llama a TW_Functions_QueryExternalStock)
      //
      const storeAdmin = await getState().admin
      if (storeAdmin.users.selectedUser.tipoUsuario == "V" || storeAdmin.users.selectedUser.tipoUsuario == "Vendedor") {
        tarifa = localStorage.getItem('tarifaDefecto')
      }
      await axios.get(`${devuelveBasePath()}/query-page-products/${code}/${productos.join("|")}/?customerPriceGroup=${tarifa}`).then(response => {
        if (response.data.result && response.data.result.return_value != undefined) {
          productosNav = JSON.parse(response.data.result.return_value).Items
        }
      })
      //
      //Metemos los productos que no haya devuelto NAV como vacios
      //
      productos.forEach(async producto => {
        if ((productosNav.find(e => e.Model == producto) == undefined)) {
          productosNav.push({Model:producto,
                             Description:"",
                             Mark:"",
                             CategoryDescription:"",
                             BarCode:"",
                             InventoryAvailable:"0",
                             InventoryDeposit:"0",
                             Status:"",
                             EntryDate1:"",
                             EntryDate2:"",
                             EntryDate3:"",
                             EntryQty1:"",
                             EntryQty2:"",
                             EntryQty3:"",
                             CustomerSalesPrice:"0",
                             CustomerSalesDiscount:"",
                             PVRSalesPrice:"0",
                             sinDatosNav: true})
        }
      })
      dispatch({ 
        type: `${prefix}/GET_PRODUCTS_PAG`, 
        data: productosNav 
      })
    } catch (err) {
      
      console.error(err)
    }
  }
}

// Función para ordenar por status
function ordenarPorStatus(productos) {
  const prioridad = {
      // eslint-disable-next-line quote-props
      "ACTIVA": 1,
      "FIN EXISTENCIAS": 2,
      // eslint-disable-next-line quote-props
      "PROXIMAMENTE": 3,
      // eslint-disable-next-line quote-props
      "DESCATALOGADA": 4,
      "NO DESARROLLADO": 5
  };

  return productos.sort((a, b) => {
      return prioridad[a.status] - prioridad[b.status];
  });
}

// Función para obtener todos los clubs del PIM con sus detalles (imagen, nombre, orden)
const obtenerClubs = async () => {
  try {
    const { data: clubs } = await instance().get(`/Clubs`)
    return clubs
  } catch (error) {
    console.error("Error al obtener los clubs:", error)
    return []
  }
}

const combinarListas = async (clubsActivosDelCliente, listaClubsDelPIM) => {
  try {
    // Lista final combinada con datos específicos de cada lista
    const listaCombinada = clubsActivosDelCliente.map(clubDelUsuario => {
      // Buscamos el detalle del club en la segunda lista usando `nombre`
      const clubDelPIM = listaClubsDelPIM.find(clubPIM => clubPIM.nombre === clubDelUsuario.club)

      // Combinamos solo los datos específicos de clubDelUsuario y clubDelPIM
      if (clubDelPIM) {
        return {
          id: clubDelPIM.id,
          club: clubDelUsuario.club,
          customerNo: clubDelUsuario.customerNo,
          initDate: clubDelUsuario.initDate,
          endDate: clubDelUsuario.endDate,
          showInB2B: clubDelUsuario.showInB2B,
          descripcion: clubDelPIM.descripcion,
          filtroMarcas: clubDelPIM.filtroMarcas,
          filtroCategorias: clubDelPIM.filtroCategorias,
          imagenMiniatura: clubDelPIM.imagenMiniatura,
          imagenGrande: clubDelPIM.imagenGrande,
          orden: clubDelPIM.orden
        }
      } else {
        return null  // Ignoramos si no hay detalles del club
      }
    }).filter(item => item !== null) // Eliminamos entradas nulas si no hay coincidencia en listaCombinada

    return listaCombinada
  } catch (error) {
    console.error("Error al combinar las listas: ", error)
    return []
  }
}

// Función asíncrona para obtener y filtrar los clubs que puede ver el cliente
export const obtenerClubsQuePuedeVer = async (cliente) => {
  try {
    // Consulta para obtener la lista de clubs del cliente
    const filtro = `customerNo eq '${cliente}'`

    // Llama a BC para obtener los CLUBS en los que el cliente es miembro
    const response = await apiNavisionNew.navisionControllerGetendPoint('clubmember', filtro, 100000, 0, undefined, undefined, true)

    const { data } = response
    if (data.value.length > 0) {
      const listaClubsDelPIM = await obtenerClubs() // Obtenemos todos los Clubs dados de alta en el PIM

      const clubsActivosDelCliente = data.value.filter(club => club.showInB2B === true) // Obtenemos solo los clubs activos para el cliente

      // Eliminar duplicados basados en el nombre del club
      const clubsUnicos = Array.from(
        new Map(clubsActivosDelCliente.map(club => [club.club, club])).values()
      );

      const idsClubsActivosDelCliente = clubsUnicos.map(club => club.club)
      const clubsDelCliente = listaClubsDelPIM
        .filter(club => idsClubsActivosDelCliente.includes(club.nombre)) // Filtra por nombre que coincide con el ID
        .sort((a, b) => a.orden - b.orden) // Ordena los clubs por `orden`

      const listaFinalClubsDelCliente = await combinarListas(clubsUnicos, clubsDelCliente)
      return listaFinalClubsDelCliente
    } else {
      console.log('No se encontraron clubs asociados al cliente')
      return [] // Si no hay clubs, retornamos la lista vacía
    }
  } catch (error) {
    console.error('Error al obtener los clubs del cliente:', error);
    return [];
  }
};

// Función asíncrona para obtener y filtrar los productos basados en clubes del cliente
export const obtenerProductosPorClubes = async (listaDeClubsDelCliente) => {
  try {
    if (listaDeClubsDelCliente.length > 0) {
      // Obtener la fecha de hoy en formato ISO (sin la parte de tiempo)
      const fechaHoy = new Date().toISOString().split('T')[0]
      // Consulta para obtener los Tipos de Rango de PIM (Oro, plata, bronce, etc..)
      const { data: tiposRangoPIM } = await instance().get(`/TiposRango`);

      // Filtramos solo los clubs, cuya fecha actual esté en el rango de inicio y fin, lo que indica que el cliente esta dado de alta en ese club
      const clubsActivos = listaDeClubsDelCliente.filter(club => {
        const inicioActivo = new Date(club.initDate).toISOString().split('T')[0]
        const finActivo = new Date(club.endDate).toISOString().split('T')[0]

        // Verifica que la fecha actual esté en el rango
        return fechaHoy >= inicioActivo && fechaHoy <= finActivo
      })

      const clubIds = clubsActivos.map(club => club.id) // -> obtener solo los IDs de los clubs activos

      if (clubIds.length > 0) {
        const filter = {
          where: {
            clubId: { inq: clubIds } // Condición IN con los IDs obtenidos
          }
        };

        // Consultamos todos los ProductosPorRango que pertenecen a los clubs activos del cliente
        const { data: listaDeProductosPorRango } = await instance().get(`/ProductosPorRango?filter=${encodeURIComponent(JSON.stringify(filter))}`);

        // Filtrar ProductosPorRango cuyo rango de fechas incluya la fecha de hoy
        const productosPorRangoQuePuedeVerHoy = listaDeProductosPorRango.filter(producto => {
          const desdeFecha = new Date(producto.desdeFecha).toISOString().split('T')[0];
          const hastaFecha = new Date(producto.hastaFecha).toISOString().split('T')[0];

          // Comparar si la fecha de hoy está dentro del rango de fechas del producto
          return fechaHoy >= desdeFecha && fechaHoy <= hastaFecha;
        });

        console.log('ProductosPorRango que puede ver Hoy: ', productosPorRangoQuePuedeVerHoy);

        // Mapear sobre productosPorRangoQuePuedeVerHoy para añadir el atributo 'rangoImagen'
        const productosPorRangoConImagen = productosPorRangoQuePuedeVerHoy.map((producto) => {
          // Buscar el rango correspondiente en tiposRangoPIM basado en rangoId
          const rangoCorrespondiente = tiposRangoPIM.find(rango => rango.id === producto.rangoId);

          // Si se encuentra el rango, añadir la propiedad 'rangoImagen '
          if (rangoCorrespondiente) {
            return {
              ...producto,
              rangoImagen: rangoCorrespondiente.imagen, // Añadir la imagen del rango correspondiente
              rangoId: rangoCorrespondiente.id, // Añadir el ID del rango correspondiente
              rangoNombre: rangoCorrespondiente.rango // Añadir el nombre del rango correspondiente
            };
          }

          // Si no se encuentra el rango, devolver el producto sin cambios
          return producto;
        });
        return productosPorRangoConImagen; // Retornar los productos filtrados con la imagen del rango
      } else {
        console.log('El cliente no tiene clubs activos');
        return [];
      }
    } else {
      console.log('No se encontraron clubs para el cliente');
      return [];
    }
  } catch (error) {
    console.error('Error al obtener productos por clubes:', error);
    return [];
  }
};

// Función asíncrona para obtener todos los tipos de rango dados de alta en el PIM
export const obtenerTiposDeRango = async () => {
  try {
    const { data: tiposRangoPIM } = await instance().get(`/TiposRango`);
    // Ordenar los tipos de rango por el campo 'orden' de menor a mayor
    const listaOrdenada = tiposRangoPIM.sort((a, b) => a.orden - b.orden);
    // Crear una nueva lista con solo el atributo 'rango'
    const listaDeRangos = listaOrdenada.map(item => item.rango);
    return listaDeRangos;
  } catch (error) {
    console.error('Error al obtener los clubs del cliente:', error);
    return [];
  }
};

//Jerarquía de los rangos = ["0",      "1",     "2",    "3",     "4"]
const jerarquiaRangos = ["Diamante", "Platino", "Oro", "Plata", "Bronce"]; // Segun Marce esta es la gerarquía de los rangos - 0 es el más alto y 4 el más bajo

// Función para obtener el nivel de jerarquía de un rango
function obtenerNivelDeJerarquia(rangoNombre) {
  return jerarquiaRangos.indexOf(rangoNombre);
}

// ** GET Products
export const getAllProducts = (cliente, intl) => {
  return async (dispatch, getState) => {
    try {
      const { perPage, page, sortBy, q } = getState().ecommerce.params
      // llamamos a la función para obtener unicamente la lista de clubs que puede ver el cliente
      const clubsQuePuedeVer = await obtenerClubsQuePuedeVer(cliente)
      // Llamamos a la función para obtener los productosPorRango que puede ver hoy
      const productosPorRangoQuePuedeVerHoy = await obtenerProductosPorClubes(clubsQuePuedeVer)

      const tiposDeRango = await obtenerTiposDeRango();

      // Extraemos los rangos que aparecen en los productos
      const rangosEnProductos = productosPorRangoQuePuedeVerHoy.map(producto => producto.rangoNombre);

      // Filtramos los tipos de rango para quedarnos solo con los que están presentes en los productos
      const rangosDisponibles = tiposDeRango.filter(rango => rangosEnProductos.includes(rango));

      // const {data: productos } = await instance().get(`/B2bProductos/*`)
      const cod = getUserData()
      if (cod.companyId !== 43) {
        const filter = {where: {
          ['customerNo']:`${cliente}`,
          ['companyId'] : cod.companyId
          }
        }
        let arrayFinalDeProductos = []
        const {data: clientes } = await clienteasApi.clientesControllerFind(JSON.stringify(filter))
        const clienteNav = clientes[0]

        // Consulta unicamente los productos que el cliente puede ver
        const { data: productos } = await instance().get('/B2bProductos/obtenerProductosFiltrados', {
          params: {
            filtro1: clienteNav.itemFilter01,
            filtro2: clienteNav.itemFilter02,
            filtro3: clienteNav.viewItemFilter01
          }
        });

        if (!(productos instanceof Array)) {
          return displayErrorMsg(intl.formatMessage({ id: 'Error bringing product data'}))
        }

        arrayFinalDeProductos = productos.map(product => {
          return { ...product, imagen: `${devuelveBasePathPim()}/${product.imagen}`, obteniendoStock: true }
        })

        // Si existen productosPorRangoQuePuedeVerHoy, añadir los atributos 'rangoImagen' y 'clubId' a arrayFinalDeProductos
        if (productosPorRangoQuePuedeVerHoy.length > 0) {
          // Hacemos un mapeo de arrayFinalDeProductos para añadir atributos
          arrayFinalDeProductos = arrayFinalDeProductos.map((producto) => {
            // Filtrar productos por SKU y obtener el de mayor jerarquía
            const productosFiltradosPorSKU = productosPorRangoQuePuedeVerHoy
              .filter((productoPorRango) => productoPorRango.skuProducto === producto.sku)
              .sort((a, b) => obtenerNivelDeJerarquia(a.rangoNombre) - obtenerNivelDeJerarquia(b.rangoNombre));

            // Tomar el primer producto de mayor jerarquía si existen coincidencias
            const productoEncontrado = productosFiltradosPorSKU[0];

            // Si encontramos el producto filtrado, añadimos los atributos deseados
            if (productoEncontrado) {
              return {
                ...producto, // Mantengo todas las propiedades del producto original y añado las siguientes
                rangoImagen: productoEncontrado.rangoImagen,
                rangoId: productoEncontrado.rangoId,
                rangoNombre: productoEncontrado.rangoNombre,
                clubId: productoEncontrado.clubId
              };
            }
            // Si no se encuentra, devolvemos el producto original sin cambios
            return producto;
          });
        } else {
          console.log(`El cliente: ${cliente} No tiene productosPorRango que pueda ver hoy`);
        }

        if (arrayFinalDeProductos.length === 0) {
          displayInfoMsg(intl.formatMessage({ id: 'There are no products that match the filters configured in BC for this customer.'}))
        }

        dispatch({ type: `${prefix}/GET_ALL_PRODUCTS`, data: arrayFinalDeProductos })
        //
        //Obtenemos las marcas que puede ver el cliente con un await para que le de tiempo a hacer la consulta a la bbdd
        //
        const marcas = await Promise.all(clienteNav.markFilter.split('|').map(elemento => getNombreMarca(elemento)).filter(Boolean));
        dispatch({ type: `${prefix}/SET_MARCAS`, data: marcas.sort() })
        dispatch({ type: `${prefix}/SET_TIPOS_DE_RANGO`, data: rangosDisponibles })
        dispatch(getFilters())
        localStorage.setItem('cargandoPantalla', 'NO')

        //dispatch(refreshDisplayedProducts())
        const products = arrayFinalDeProductos.slice(((page || 1) * (perPage || 9)) - (perPage || 9), (page || 1) * (perPage || 9))
        const allProducts = arrayFinalDeProductos
        dispatch(getProducts({ params: { perPage, page, sortBy, q }, page: 1, tarifa: localStorage.getItem('tarifaDefecto'), code: localStorage.getItem('clienteDefecto').split(' ')[0]}))
        return dispatch({ type: `${prefix}/REFRESH_PRODUCTS`, products, allProducts, params: { perPage, page, sortBy, q } })
      } else {
        //Logica para multiempresa
        const codigoVendedor = cod.tipoUsuario === 'V' ? cod?.codVendedorCliente : undefined
        const {data: clientes } = await clienteasApi.clientesControllerSacarPrimerRegistroUnicaEmpresa(cliente, codigoVendedor)
        const clientesArray = Array.isArray(clientes) ? clientes : [clientes];
        const {data: productos } = await instance().get('/B2bProductos/obtenerProductosFiltrados', {
          params: {
            filtro1: undefined,
            filtro2: undefined,
            filtro3: undefined,
            multiempresas: true,
            cliente: JSON.stringify(clientesArray)  // Enviar el array de objetos como un string JSON
          }
        });
        let marcasFinales = []
        for (const cliente of clientesArray) {
          //
          //Obtenemos las marcas que puede ver el cliente con un await para que le de tiempo a hacer la consulta a la bbdd
          //
          const nombresMarca = await Promise.all(cliente.markFilter.split('|').map(elemento => getNombreMarca(elemento)).filter(Boolean));
          marcasFinales = marcasFinales.concat(nombresMarca)
        }
        marcasFinales = [...new Set(marcasFinales)].filter(item => item !== undefined);
        let arrayFinalDeProductos = productos.map(product => {
          return { ...product, imagen: `${devuelveBasePathPim()}/${product.imagen}`, obteniendoStock: true }
        })
        const allProducts = arrayFinalDeProductos
        
        // Si existen productosPorRangoQuePuedeVerHoy, añadir los atributos 'rangoImagen' y 'clubId' a arrayFinalDeProductos
        if (productosPorRangoQuePuedeVerHoy.length > 0) {
          // Hacemos un mapeo de arrayFinalDeProductos para añadir atributos
          arrayFinalDeProductos = arrayFinalDeProductos.map((producto) => {
            // Filtrar productos por SKU y obtener el de mayor jerarquía
            const productosFiltradosPorSKU = productosPorRangoQuePuedeVerHoy
              .filter((productoPorRango) => productoPorRango.skuProducto === producto.sku)
              .sort((a, b) => obtenerNivelDeJerarquia(a.rangoNombre) - obtenerNivelDeJerarquia(b.rangoNombre));

            // Tomar el primer producto de mayor jerarquía si existen coincidencias
            const productoEncontrado = productosFiltradosPorSKU[0];

            // Si encontramos el producto filtrado, añadimos los atributos deseados
            if (productoEncontrado) {
              return {
                ...producto, // Mantengo todas las propiedades del producto original y añado las siguientes
                rangoImagen: productoEncontrado.rangoImagen,
                rangoId: productoEncontrado.rangoId,
                rangoNombre: productoEncontrado.rangoNombre,
                clubId: productoEncontrado.clubId
              };
            }
            // Si no se encuentra, devolvemos el producto original sin cambios
            return producto;
          });
        } else {
          console.log(`El cliente: ${cliente} No tiene productosPorRango que pueda ver hoy`);
        }

        if (arrayFinalDeProductos.length === 0) {
          displayInfoMsg(intl.formatMessage({ id: 'There are no products that match the filters configured in BC for this customer.'}))
        }
        const products = arrayFinalDeProductos.slice(((page || 1) * (perPage || 9)) - (perPage || 9), (page || 1) * (perPage || 9))
        dispatch({ type: `${prefix}/GET_ALL_PRODUCTS`, data: arrayFinalDeProductos })
        dispatch({ type: `${prefix}/SET_MARCAS`, data: marcasFinales })
        // dispatch({ type: `${prefix}/SET_CLUBS`, data: clubsQuePuedeVer })
        dispatch({ type: `${prefix}/SET_TIPOS_DE_RANGO`, data: rangosDisponibles })
        dispatch(getFilters())
        localStorage.setItem('cargandoPantalla', 'NO')
        //dispatch(refreshDisplayedProducts())
        dispatch(getProducts({ params: { perPage, page, sortBy, q }, page: 1, tarifa: localStorage.getItem('tarifaDefecto'), code: localStorage.getItem('clienteDefecto').split(' ')[0]}))
        return dispatch({ type: `${prefix}/REFRESH_PRODUCTS`, products, allProducts, params: { perPage, page, sortBy, q } })
      }
    } catch (err) {
      console.error(err.message)
    }
  }
}

// ** GET Products
export const getAllProductsDocumentacion = (model, intl) => {
  return async (dispatch, getState) => {
    try {
      const { data: productos } = await instance().get(`/B2bProductos/${model}`)
      if (!(productos instanceof Array)) {
        return displayErrorMsg(intl.formatMessage({ id: 'Error bringing product data'}))
      }
      const products = productos.map(product => {
        return { ...product, imagen: `${devuelveBasePathPim()}/${product.imagen}` }
      })
      // products = eliminaRepetidos(products)
      // products = ordenarPorStatus(products);
      // dispatch({ type: `${prefix}/GET_ALL_PRODUCTS`, data: products })
      
      //return dispatch(refreshDisplayedProducts())
      return products
    } catch (err) {
      console.error(err.message)
    }
  }
}

export async function getUsers() {
  //
  //Cambiamos la funcionalidad para que busque por id de la tabla ya que el code está obsoleto
  //
  try {
    const { id } = getUserData()
    const filter = { where: { id: { eq: id } } }
    const { data } = await apiUser.usersControllerFind(JSON.stringify(filter))
    return data
  } catch (err) {
    console.error(err.message)
  }
}

export async function getNavUsersData() {
  try {
    const { data } = await vendedorApi.vendedorControllerFind()
    return data
  } catch (err) {
    console.error(err.message)
  }
}

// Función para verificar si el volumen de un producto es mayor o igual a 100
async function hayVolumenMayorOIgual100(producto, intl) {
  if (producto.volumen != null && producto.volumen !== undefined) {
    const volumen = typeof producto.volumen === 'string' ? parseFloat(producto.volumen.replace(',', '.')) : parseFloat(producto.volumen);
    const volumenMayorOIgual100 = volumen >= 100;
    if (volumenMayorOIgual100) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: intl.formatMessage({ id: 'Producto no permitido' }),
        html: intl.formatMessage({ id: 'Este producto no puede añadirse al carrito porque su <b>volumen excede el límite permitido</b>. Por favor, contacte con SVAN.' }),
        showConfirmButton: true
      });
      return volumenMayorOIgual100;
    }
  }
  return false;
}

// ** Add Item to Cart
export const addToCart = (model, rangoNombre, rangoImagen, intl, filtroGuardado) => {
  console.log('rangoNombre:', rangoNombre, 'rangoImagen:', rangoImagen);
  return async (dispatch, getState) => {
    try {
      if (localStorage.getItem("carritoRepuestos") === 'true') {
        return Swal.fire({
          position: 'center',
          icon: 'warning',
          title: intl.formatMessage({ id: 'Shopping cart'}),
          text: intl.formatMessage({ id: 'The current cart is a spare parts cart. To add an entire product, the current cart will be emptied first.'}),
          showConfirmButton: true,
          showCancelButton: true,
          cancelButtonColor: '#808080',
          cancelButtonText: 'Cancel'
        }).then(async (result) => {
          if (result.isConfirmed) {
            localStorage.setItem("carritoRepuestos", "false")
            return dispatch({ type: `${prefix}/CLEAR_CART` })
          }
        })
      } else {
        if (localStorage.getItem("carritoNormal") === 'false' || !localStorage.getItem("carritoNormal")) {
          localStorage.setItem("carritoNormal", 'true')
        }
        const { cart } = getState().ecommerce
        const storeAdmin = await getState().admin
        let tarifa = ''
        if (storeAdmin.users.selectedUser.tipoUsuario == "V" || storeAdmin.users.selectedUser.tipoUsuario == "Vendedor") {
          tarifa = localStorage.getItem('tarifaDefecto')
        }
        const usuario = storeAdmin.users.selectedUser.tipoUsuario == "V" || storeAdmin.users.selectedUser.tipoUsuario == "Vendedor" ? storeAdmin.users.clienteSelected : storeAdmin.users.selectedUser.codVendedorCliente
        const {data: productosPim } = await instance().get(`/B2bProductos/${model}`)

        const volumenMayorOIgual100 = await hayVolumenMayorOIgual100(productosPim[0], intl);
        if (volumenMayorOIgual100) {
          return; // Si el volumen es mayor o igual a 100, no continuar con agregar el producto al carrito
        }
        
        if (storeAdmin.users.selectedUser.companyId !== 43) {
          const { data } = await axios.get(`${devuelveBasePath()}/query-page-products/${usuario.split(' ')[0]}/${model}/?customerPriceGroup=${tarifa}`)
          const productoNav = JSON.parse(data.result.return_value)
          const producto = {...productoNav.Items[0], ...productosPim[0]}
          producto.PVR = producto.PVRSalesPrice
          producto.PVC = producto.CustomerSalesPrice
          producto.imagen = `${devuelveBasePathPim()}/${producto.imagen}`
          producto.PVC_OriginalBC = producto.CustomerSalesPrice
          producto.rangoNombre = rangoNombre ? rangoNombre : ''
          producto.rangoImagen = rangoImagen ? rangoImagen : ''

          if (filtroGuardado) {
            producto.CustomerSalesDiscount = filtroGuardado.descuento;
            producto.porcentajeDescuento = filtroGuardado.descuento;
            producto.qty = filtroGuardado.cantidad;
          } else {
            producto.qty = 1; // Si no hay filtro, la cantidad por defecto es 1
          }

          const { cart } = getState().ecommerce; // Obtener el carrito actualizado antes de modificarlo

          let updatedCart = [...cart]; // Copia el carrito actual
          
          //let updatedCart = [];
          // Si existe, actualiza la cantidad en lugar de solo sumarla
          const existingItem = cart.find(item => item.model === model);
          
          if (existingItem) {
            updatedCart = cart.map(item => {
              if (item.model === model) {
                return { ...item, qty: filtroGuardado ? filtroGuardado.cantidad : item.qty + 1 };
              } else {
                return item;
              }
            });
          } else {
            updatedCart = cart.concat(producto);
          }

          // let updatedCart = []
          // // Si existe aumenta cantidad
          // if (cart.find(item => item.model === model)) updatedCart = cart.map(item => (item.model === model ? { ...item, qty: item.qty + 1 } : item))
          // // Si no existe en carro lo añade
          // else updatedCart = cart.concat({ ...producto, qty: 1 })
          // Dispatch del carrito actualizado
          dispatch({ type: `${prefix}/ADD_TO_CART`, data: updatedCart })
          await armarFiltroCarrito(updatedCart)
        } else {
          let companies = [];
          let listaSlugs = [];
          const results = [];
          await fetchCompaniesForProducts(productosPim, usuario).then(allCompaniesData => {
            companies = Object.keys(allCompaniesData);
            companies.forEach((element, index) => {
              console.log('Elemento:', element);
              listaSlugs = allCompaniesData[element].map(item => item.slug);
              results.push({
                [element]: listaSlugs
              });
            });
          }).catch(error => {
            console.error('Error en la llamada a fetchCompaniesForProducts:', error);
          }); 
          const { data } = await axios.get(`${devuelveBasePath()}/query-page-products-empresa/${localStorage.getItem('clienteDefecto').split(' ')[0]}/${listaSlugs[0]}/${companies[0]}/?customerPriceGroup=${tarifa}`)
          const productoNav = JSON.parse(data.result.return_value)
          const producto = {...productoNav.Items[0], ...productosPim[0]}
          producto.PVR = producto.PVRSalesPrice
          producto.PVC = producto.CustomerSalesPrice
          producto.imagen = `${devuelveBasePathPim()}/${producto.imagen}`
          producto.PVC_OriginalBC = producto.CustomerSalesPrice
          producto.rangoNombre = rangoNombre ? rangoNombre : ''
          producto.rangoImagen = rangoImagen ? rangoImagen : ''

          if (filtroGuardado) {
            producto.CustomerSalesDiscount = filtroGuardado.descuento;
            producto.porcentajeDescuento = filtroGuardado.descuento;
            producto.qty = filtroGuardado.cantidad;
          } else {
            producto.qty = 1; // Si no hay filtro, la cantidad por defecto es 1
          }

          const { cart } = getState().ecommerce; // Obtener el carrito actualizado antes de modificarlo

          let updatedCart = [...cart]; // Copia el carrito actual
          
          //let updatedCart = [];
          // Si existe, actualiza la cantidad en lugar de solo sumarla
          const existingItem = cart.find(item => item.model === model);
          
          if (existingItem) {
            updatedCart = cart.map(item => {
              if (item.model === model) {
                return { ...item, qty: filtroGuardado ? filtroGuardado.cantidad : item.qty + 1 };
              } else {
                return item;
              }
            });
          } else {
            updatedCart = cart.concat(producto);
          }

          // let updatedCart = []
          // // Si existe aumenta cantidad
          // if (cart.find(item => item.model === model)) updatedCart = cart.map(item => (item.model === model ? { ...item, qty: item.qty + 1 } : item))
          // // Si no existe en carro lo añade
          // else updatedCart = cart.concat({ ...producto, qty: 1 })

          // Dispatch del carrito actualizado
          dispatch({ type: `${prefix}/ADD_TO_CART`, data: updatedCart })
          await armarFiltroCarrito(updatedCart)
        }
      }
    } catch (err) {
      console.error(err)
    }
  }
}

export const addToCartRepuestos = (model, intl) => {
  return async (dispatch, getState) => {
    try {
      if (localStorage.getItem("carritoNormal") === 'true') {
        return Swal.fire({
          position: 'center',
          icon: 'warning',
          title: intl.formatMessage({ id: 'Shopping cart'}),
          text: intl.formatMessage({ id: 'The current cart is full of products. To add a replacement, the current cart will be emptied first.'}),
          showConfirmButton: true,
          showCancelButton: true,
          cancelButtonColor: '#808080',
          cancelButtonText: 'Cancel'
        }).then(async (result) => {
          if (result.isConfirmed) {
            localStorage.setItem("carritoNormal", "false")
            return dispatch({ type: `${prefix}/CLEAR_CART` })
          }
        })
      } else {
        if (localStorage.getItem("carritoRepuestos") === 'false' || !localStorage.getItem("carritoRepuestos")) {
          localStorage.setItem("carritoRepuestos", 'true')
        }
        const getDocumentId = `almacenPropio_${model.Model}`;
        const cantidad = document.getElementById(getDocumentId).value === '' ? 1 : document.getElementById(getDocumentId).value
        const { cart } = getState().ecommerce
        const modeloProductoRepuesto = modeloProductoParaRepuesto 
        modeloProductoRepuesto.id = getState().ecommerce.cart.length
        modeloProductoRepuesto.model = model.Model
        modeloProductoRepuesto.Model = model.Model
        const nombre = `${model.no} ${model.description ? model.description : model.Description}`
        modeloProductoRepuesto.BarCode = model.BarCode ? model.BarCode : ''
        modeloProductoRepuesto.name = nombre
        modeloProductoRepuesto.sku = model.Model
        modeloProductoRepuesto.slug = model.Model
        modeloProductoRepuesto.Mark = model.Mark ? model.Mark : ''
        modeloProductoRepuesto.category = model.CategoryDescription === 'RPT' ? 'REPUESTOS' : ''
        modeloProductoRepuesto.CategoryDescription = model.CategoryDescription ? model.CategoryDescription : ''
        modeloProductoRepuesto.description = model.description ? model.description : model.Description
        modeloProductoRepuesto.Description = model.description ? model.description : model.Description
        modeloProductoRepuesto.fullDescription = model.description ? model.description : model.Description
        modeloProductoRepuesto.InventoryAvailable = model.InventoryAvailable ? model.InventoryAvailable : '0'
        modeloProductoRepuesto.InventoryDeposit = model.InventoryDeposit ? model.InventoryDeposit : '0'
        modeloProductoRepuesto.PVC = model.CustomerSalesPrice ? model.CustomerSalesPrice : '0'
        modeloProductoRepuesto.PVC_OriginalBC = model.CustomerSalesPrice ? model.CustomerSalesPrice : '0'
        modeloProductoRepuesto.PVR = model.PVRSalesPrice ? model.PVRSalesPrice : '0'
        modeloProductoRepuesto.PVRSalesPrice = model.PVRSalesPrice ? model.PVRSalesPrice : '0'
        modeloProductoRepuesto.CustomerSalesDiscount = model.CustomerSalesDiscount ? model.CustomerSalesDiscount : '0'
        modeloProductoRepuesto.status = model.Status ? model.Status : ''
        modeloProductoRepuesto.volumen = '0'
        const { data: productoPim } = await instance().get(`/B2bProductos/${model.Model}`)

        const volumenMayorOIgual100 = await hayVolumenMayorOIgual100(productoPim[0], intl);
        if (volumenMayorOIgual100) {
          return; // Si el volumen es mayor o igual a 100, no continuar con agregar el producto al carrito
        }

        const producto = {...productoPim[0]}
        modeloProductoRepuesto.imagen = `${devuelveBasePathPim()}/${producto.imagen}`
        modeloProductoRepuesto.qty = cantidad
        let updatedCart = []
        // Si existe aumenta cantidad
        if (cart.find(item => item.model === modeloProductoRepuesto.model)) updatedCart = cart.map(item => (item.model === modeloProductoRepuesto.model ? { ...item, qty: item.qty + 1 } : item))
        // Si no existe en carro lo añade
        else updatedCart = cart.concat({ ...modeloProductoRepuesto, qty: cantidad })
        // Dispatch del carrito actualizado
        dispatch({ type: `${prefix}/ADD_TO_CART`, data: updatedCart })
      }
    } catch (err) {
      console.error(err)
    }
  }
}

// ** Añadir item/items al carrito con cantidad seteada
export const addToCartQty = (arrItems, rangoNombre, rangoImagen, PVRSalesPrice, InventoryAvailable, intl) => {
  return async (dispatch, getState) => {

    if (localStorage.getItem("carritoRepuestos") === 'true') {
      return Swal.fire({
        position: 'center',
        icon: 'warning',
        title: intl.formatMessage({ id: 'Shopping cart'}),
        text: intl.formatMessage({ id: 'The current cart is a spare parts cart. To add an entire product, the current cart will be emptied first.'}),
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonColor: '#808080',
        cancelButtonText: 'Cancel'
      }).then(async (result) => {
        if (result.isConfirmed) {
          localStorage.setItem("carritoRepuestos", "false")
          return dispatch({ type: `${prefix}/CLEAR_CART` })
        }
      })
    } else {
      if (localStorage.getItem("carritoNormal") === 'false' || !localStorage.getItem("carritoNormal")) {
        localStorage.setItem("carritoNormal", 'true')
      }
      const { cart } = await getState().ecommerce
      const storeAdmin = await getState().admin
      const dataUsers = storeAdmin.users
      //const tarifa = dataUsers.tarifaSelected == "" ? "*" : dataUsers.tarifaSelected
      let tarifa = ''
      if (storeAdmin.users.selectedUser.tipoUsuario == "V" || storeAdmin.users.selectedUser.tipoUsuario == "Vendedor") {
        tarifa = localStorage.getItem('tarifaDefecto')
      }
      const usuario = dataUsers.selectedUser.tipoUsuario == "V" ? dataUsers.clienteSelected : dataUsers.selectedUser.codVendedorCliente
      let updatedCart = [...cart]
  
      await arrItems.forEach(async pr => {
        const { model, qty } = pr
        const { data: productosPim } = await instance().get(`/B2bProductos/${model}`)

        const volumenMayorOIgual100 = await hayVolumenMayorOIgual100(productosPim[0], intl);
        if (volumenMayorOIgual100) {
          return; // Si el volumen es mayor o igual a 100, no continuar con agregar el producto al carrito
        }

        if (storeAdmin.users.selectedUser.companyId !== 43) {
          const { data } = await axios.get(`${devuelveBasePath()}/query-page-products/${usuario}/${model}/?customerPriceGroup=${tarifa}`)
          const productoNav = JSON.parse(data.result.return_value)
          const producto = {...productoNav.Items[0], ...productosPim[0]}
          producto.PVR = producto.PVRSalesPrice
          producto.PVC = producto.CustomerSalesPrice
          producto.imagen = `${devuelveBasePathPim()}/${producto.imagen}`
          producto.PVC_OriginalBC = producto.CustomerSalesPrice
          producto.rangoNombre = rangoNombre ? rangoNombre : ''
          producto.rangoImagen = rangoImagen ? rangoImagen : ''
    
          if (!producto) displayErrorMsg(`${intl.formatMessage({ id: 'Product' })} ${model} ${intl.formatMessage({ id: 'not found' })}`)
          // Si existe aumenta cantidad
          if (updatedCart.find(item => item.model === model)) updatedCart = updatedCart.map(item => (item.model === model ? { ...item, qty: item.qty + qty } : item))
          // Si no existe en carro lo añade
          else updatedCart = updatedCart.concat({ ...producto, qty })
          // Dispatch del carrito actualizado
          dispatch({ type: `${prefix}/ADD_TO_CART`, data: updatedCart })
        } else {
          let companies = [];
          let listaSlugs = [];
          const results = [];
          await fetchCompaniesForProducts(productosPim, usuario).then(allCompaniesData => {
            companies = Object.keys(allCompaniesData);
            companies.forEach((element, index) => {
              console.log('Elemento:', element);
              listaSlugs = allCompaniesData[element].map(item => item.slug);
              results.push({
                [element]: listaSlugs
              });
            });
          }).catch(error => {
            console.error('Error en la llamada a fetchCompaniesForProducts:', error);
          }); 
          const { data } = await axios.get(`${devuelveBasePath()}/query-page-products-empresa/${localStorage.getItem('clienteDefecto').split(' ')[0]}/${listaSlugs[0]}/${companies[0]}/?customerPriceGroup=${tarifa}`)
          const productoNav = JSON.parse(data.result.return_value)
          const producto = {...productoNav.Items[0], ...productosPim[0]}
          producto.PVR = producto.PVRSalesPrice
          producto.PVC = producto.CustomerSalesPrice
          producto.imagen = `${devuelveBasePathPim()}/${producto.imagen}`
          producto.PVC_OriginalBC = producto.CustomerSalesPrice
          producto.rangoNombre = rangoNombre ? rangoNombre : ''
          producto.rangoImagen = rangoImagen ? rangoImagen : ''
    
          if (!producto) displayErrorMsg(`${intl.formatMessage({ id: 'Product' })} ${model} ${intl.formatMessage({ id: 'not found' })}`)
          // Si existe aumenta cantidad
          if (updatedCart.find(item => item.model === model)) updatedCart = updatedCart.map(item => (item.model === model ? { ...item, qty: item.qty + qty } : item))
          // Si no existe en carro lo añade
          else updatedCart = updatedCart.concat({ ...producto, qty })
          // Dispatch del carrito actualizado
          dispatch({ type: `${prefix}/ADD_TO_CART`, data: updatedCart })
        }
      })
      return dispatch({ type: `${prefix}/ADD_TO_CART`, data: updatedCart }) 
    }
  }
}

// ** Editar cantidad de item en carrito
export const editCartQty = (model, qty) => {
  return async (dispatch, getState) => {
    const cart = getState().ecommerce.cart
    //
    //Con esto filter(a => a) hacemos que filtre solo por los que sean elementos del carrito, por si se ha metido algo raro con PORTES...
    //
    const updatedCart = [...cart].filter(a => a).map(item => (item.model === model ? { ...item, qty } : item))
    await armarFiltroCarrito(updatedCart)
    return dispatch({ type: `${prefix}/SWITCH_QTY`, data: updatedCart })
  }
}

// ** Editar cantidad de item en carrito
export const editCartDescuento = (model, descuento) => {
  return async (dispatch, getState) => {
    const cart = getState().ecommerce.cart
    //
    //Con esto filter(a => a) hacemos que filtre solo por los que sean elementos del carrito, por si se ha metido algo raro con PORTES...
    //
    const updatedCart = [...cart].filter(a => a).map(item => (item.model === model ? { ...item, porcentajeDescuento: descuento } : item))
    //await armarFiltroCarrito(updatedCart)
    //
    //Tanto el SWITCH_QTY, como el SWITCH_PVR o el UPDATE_PVC... actualizan el carrito por lo que utilizo uno de ellos sin necesidad de crear otro
    //
    return dispatch({ type: `${prefix}/SWITCH_QTY`, data: updatedCart })
  }
}

export const editCartPrice = (model, CustomerSalesPrice, CustomerSalesDiscount) => {
  return async (dispatch, getState) => {
    const cart = getState().ecommerce.cart
    const updatedCart = [...cart].map(item => (item.model === model ? { ...item, CustomerSalesPrice, CustomerSalesDiscount, porcentajeDescuento: CustomerSalesDiscount } : item))
    await armarFiltroCarrito(updatedCart)
    return dispatch({ type: `${prefix}/SWITCH_PVR`, data: updatedCart })
  }
}

// FUNCION PARA PODER ACTUALIZAR EL PVC
export const updateItemPVC = (model, PVC) => {
  return async (dispatch, getState) => {
    const cart = getState().ecommerce.cart
    const updatedCart = [...cart].map(item => (item.model === model ? { ...item, PVC } : item))
    return dispatch({ type: `${prefix}/UPDATE_PVC`, data: updatedCart })
  }
}

// ** DELETE Cart Items
export const deleteCartItem = id => {
  return async (dispatch, getState) => {
    const updatedCart = getState().ecommerce.cart.filter(item => item.id !== id)
    await armarFiltroCarrito(updatedCart)
    dispatch({ type: `${prefix}/DELETE_CART_ITEM`, data: updatedCart })
  }
}

// ** CHANGE Items Rate
export const changeRate = rate => {
  return dispatch => dispatch({ type: `${prefix}/CHANGE_RATE`, data: rate })
}

// ** CHANGE Items Rate
export const changeGerenteSuper = gerenteSuper => {
  return dispatch => dispatch({ type: `${prefix}/GERENTE_SUPER`, data: gerenteSuper })
}

// Clear cart items
export const clearCart = () => {
  armarFiltroCarrito([])
  return dispatch => dispatch({ type: `${prefix}/CLEAR_CART` })
}

// Clear all products (used when language changes)
export const clearAllProducts = () => {
  return dispatch => dispatch({ type: `${prefix}/CLEAR_ALL_PRODUCTS` })
}

// ** Set carrito e identificador de oferta
export const setSalesQuoteCart = (productosaPasar, salesQuoteIdentifier, yourReference, deliveryType, tarifa, code, fechaRequerida, companyId) => {
  return async (dispatch) => {
    let productosNav = []    
    //
    //Llamamos a query-page-products (que al final llama a TW_Functions_QueryExternalStock)
    //
    const productosaPasarSoloIdentificadores = productosaPasar.filter(producto => producto.id).map(producto => producto.model).join("|")
    if (companyId !== 43) {
      await axios.get(`${devuelveBasePath()}/query-page-products/${code}/${productosaPasarSoloIdentificadores}/?customerPriceGroup=${tarifa}`).then(async response => {
        if (response.data.result && response.data.result.return_value != undefined) {
          //
          //Arreglamos los productos devueltos
          //
          productosNav = JSON.parse(response.data.result.return_value).Items
          //
          //Devolvemos los datos de Nav junto con la información del Pim
          //
          const cargaProductos = async (productosNav) => {
            return await Promise.all(productosNav.map(async (producto) => {
              if (producto != "" && producto != undefined && producto != null) {
                const { data: productosPim } = await instance().get(`/B2bProductos/${producto.Model}`);
                const datosProductoaPasar = productosaPasar.find(productoaPasar => productoaPasar.model == producto.Model)
                if (!datosProductoaPasar) return null 

                // Recogemos el precio de BC
                const precioBC = parseFloat(producto.CustomerSalesPrice) || 0;
                const precioOfertaAnterior = datosProductoaPasar.precioOfertaAnterior != null ? datosProductoaPasar.precioOfertaAnterior : '';
                const elDescuento = parseFloat(datosProductoaPasar.porcentajeDescuento || 0);

                // Analizamos si el precio en BC cambió respecto al precio que tenía la oferta
                const CambioBC = precioOfertaAnterior && precioBC !== precioOfertaAnterior;

                // si cambió, anulamos descuento y usamos el precio de BC como base
                let descuentoFinal = CambioBC ? 0 : elDescuento;
                let precioFinal = CambioBC ? precioBC : precioOfertaAnterior;
                let precioConDescuento = getPrecioTotalconDescuento(precioFinal, 1, descuentoFinal); // cantidad es 1 aquí porque es precio unitario
                let nuevoPrecioAumentado = CambioBC ? precioBC : (descuentoFinal > 0 ? '' : precioOfertaAnterior);

                // Si el precio se editó manualmente y es mayor que en BC prevalece el manual
                const precioManual = datosProductoaPasar.nuevoPrecioAumentado;
                if (precioManual > precioBC) {
                  precioFinal = precioManual;
                  descuentoFinal = 0;
                  nuevoPrecioAumentado = precioManual;
                  precioConDescuento = getPrecioTotalconDescuento(precioFinal, 1, descuentoFinal);
                }

                return {
                  ...producto, 
                        ...productosPim[0], 
                        PVR: producto.PVRSalesPrice, 
                        PVC: precioConDescuento, 
                        imagen: `${devuelveBasePathPim()}/${datosProductoaPasar.imagen}`, 
                        PVC_OriginalBC: producto.CustomerSalesPrice,
                        qty: datosProductoaPasar.qty,
                        nuevoPrecioAumentado,
                        porcentajeDescuento: descuentoFinal,
                        CustomerSalesDiscount: descuentoFinal
                       }
              }
            }));          
          };
          //
          //Llamamos a cargaProductos en modo await para que no continue hasta que termine 
          //
          let productosActualizados = []
          productosActualizados = await cargaProductos(productosNav)
          //
          // Los metemos en el carrito
          //
          //else updatedCart = cart.concat({ ...producto, qty: 1 })

          // F U N C I O N A L I D A D - P A R A - O B T E N E R - E L - R A N G O - D E - L O S - P R O D U C T O S
          // llamamos a la función para obtener unicamente la lista de clubs que puede ver el cliente = (code)
          const clubsQuePuedeVer = await obtenerClubsQuePuedeVer(code)
          // Llamamos a la función para obtener los productosPorRango que puede ver hoy el cliente
          const productosPorRangoQuePuedeVerHoy = await obtenerProductosPorClubes(clubsQuePuedeVer)

          // Si existen productosPorRangoQuePuedeVerHoy, añadir los atributos 'rangoImagen' y 'clubId' a productosActualizados
          if (productosPorRangoQuePuedeVerHoy.length > 0) {
            // Hacemos un mapeo de productosActualizados para añadir los atributos de club y rango
            productosActualizados = productosActualizados.map((producto) => {
              // Filtrar productos por SKU y obtener el de mayor jerarquía
              const productosFiltradosPorSKU = productosPorRangoQuePuedeVerHoy
                .filter((productoPorRango) => productoPorRango.skuProducto === producto.sku)
                .sort((a, b) => obtenerNivelDeJerarquia(a.rangoNombre) - obtenerNivelDeJerarquia(b.rangoNombre));

              // Tomar el primer producto de mayor jerarquía si existen coincidencias
              const productoEncontrado = productosFiltradosPorSKU[0];

              // Si encontramos el producto filtrado, añadimos los atributos deseados
              if (productoEncontrado) {
                return {
                  ...producto, // Mantengo todas las propiedades del producto original y añado las siguientes
                  rangoImagen: productoEncontrado.rangoImagen,
                  rangoId: productoEncontrado.rangoId,
                  rangoNombre: productoEncontrado.rangoNombre,
                  clubId: productoEncontrado.clubId
                };
              }
              // Si no se encuentra, devolvemos el producto original sin cambios
              return producto;
            });
          }

          dispatch({ type: `${prefix}/ADD_TO_CART`, data: productosActualizados})
          //
          //Llamamos a SET_SALES_QUOTE_CART para quitarlo de oferta 
          //
          return dispatch({ type: `${prefix}/SET_SALES_QUOTE_CART`, salesQuoteIdentifier, yourReference, fechaRequerida, deliveryType })
        }
      })
    } else {
      let listaSlugs = []
      let companies = [];
      const results = [];
      await fetchCompaniesForProducts(productosaPasar, localStorage.getItem('clienteDefecto').split(' ')[0]).then(allCompaniesData => {
        companies = Object.keys(allCompaniesData);
        companies.forEach((element, index) => {
          console.log('Elemento:', element);
          listaSlugs = allCompaniesData[element].map(item => item.slug);
          results.push({
            [element]: listaSlugs
          });
        });
      }).catch(error => {
        console.error('Error en la llamada a fetchCompaniesForProducts:', error);
      });    
      const requests = results.map(async(element, index) => {
        return axios.get(`${devuelveBasePath()}/query-page-products-empresa/${localStorage.getItem('clienteDefecto').split(' ')[0]}/${element[companies[index]].join("|")}/${companies[index]}/?customerPriceGroup=${tarifa}`)
          .then(response => {
            if (response.data.result && response.data.result.return_value != undefined) {
              return JSON.parse(response.data.result.return_value).Items;
            }
            return [];
          })
          .catch(error => {
            console.error('Error en la llamada a axios.get:', error);
            return [];
          });
      });
      
      productosNav = await Promise.all(requests);
      // Aplana el array de arrays
      const productosNavAplanados = productosNav.flat();

      console.log('Productos NAV:', productosNavAplanados);
      const cargaProductos = async (productosNavAplanados) => {
        return await Promise.all(productosNavAplanados.map(async (producto) => {
          if (producto != "" && producto != undefined && producto != null) {
            const { data: productosPim } = await instance().get(`/B2bProductos/${producto.Model}`);
            const datosProductoaPasar = productosaPasar.find(productoaPasar => productoaPasar.model == producto.Model)
            return { ...producto, 
                    ...productosPim[0], 
                    CustomerSalesDiscount: datosProductoaPasar.porcentajeDescuento,
                    PVR: producto.PVRSalesPrice, 
                    PVC: producto.CustomerSalesPrice, 
                    imagen: `${devuelveBasePathPim()}/${datosProductoaPasar.imagen}`, 
                    PVC_OriginalBC: producto.CustomerSalesPrice,
                    qty: datosProductoaPasar.qty,
                    porcentajeDescuento: datosProductoaPasar.porcentajeDescuento }
          }
        }));          
      };
      //
      //Llamamos a cargaProductos en modo await para que no continue hasta que termine 
      //
      let productosActualizados = []
      productosActualizados = await cargaProductos(productosNavAplanados)
      //
      // Los metemos en el carrito
      //
      //else updatedCart = cart.concat({ ...producto, qty: 1 })

      // F U N C I O N A L I D A D - P A R A - O B T E N E R - E L - R A N G O - D E - L O S - P R O D U C T O S
      // llamamos a la función para obtener unicamente la lista de clubs que puede ver el cliente = (code)
      const clubsQuePuedeVer = await obtenerClubsQuePuedeVer(code)
      // Llamamos a la función para obtener los productosPorRango que puede ver hoy el cliente
      const productosPorRangoQuePuedeVerHoy = await obtenerProductosPorClubes(clubsQuePuedeVer)

      // Si existen productosPorRangoQuePuedeVerHoy, añadir los atributos 'rangoImagen' y 'clubId' a productosActualizados
      if (productosPorRangoQuePuedeVerHoy.length > 0) {
        // Hacemos un mapeo de productosActualizados para añadir los atributos de club y rango
        productosActualizados = productosActualizados.map((producto) => {
          // Filtrar productos por SKU y obtener el de mayor jerarquía
          const productosFiltradosPorSKU = productosPorRangoQuePuedeVerHoy
            .filter((productoPorRango) => productoPorRango.skuProducto === producto.sku)
            .sort((a, b) => obtenerNivelDeJerarquia(a.rangoNombre) - obtenerNivelDeJerarquia(b.rangoNombre));

          // Tomar el primer producto de mayor jerarquía si existen coincidencias
          const productoEncontrado = productosFiltradosPorSKU[0];

          // Si encontramos el producto filtrado, añadimos los atributos deseados
          if (productoEncontrado) {
            return {
              ...producto, // Mantengo todas las propiedades del producto original y añado las siguientes
              rangoImagen: productoEncontrado.rangoImagen,
              rangoId: productoEncontrado.rangoId,
              rangoNombre: productoEncontrado.rangoNombre,
              clubId: productoEncontrado.clubId
            };
          }
          // Si no se encuentra, devolvemos el producto original sin cambios
          return producto;
        });
      }

      dispatch({ type: `${prefix}/ADD_TO_CART`, data: productosActualizados})
      //
      //Llamamos a SET_SALES_QUOTE_CART para quitarlo de oferta 
      //
      return dispatch({ type: `${prefix}/SET_SALES_QUOTE_CART`, salesQuoteIdentifier, yourReference, fechaRequerida, deliveryType })
    }
  } 
}

// ** Clear salesquote identifier from cart
export const clearSalesQuoteCart = () => {
  return (dispatch) => {
    return dispatch({ type: `${prefix}/CLEAR_SALES_QUOTE_CART` })
  }
}

async function crearOrderWebId(prefix) {
  try {
      const fecha = new Date();
      const añoActual = fecha.getFullYear();
      const añoActualCorto = añoActual % 100; // Obtener los dos últimos dígitos del año
      // Iterar sobre el array de productos
      const $filter = 'startswith(orderWeb, \'PW-\')'
      const $orderby = 'orderWeb desc'
      const $top = '1'
      // Obtener el último registro de la tabla 'salesQuoteHeader'
      const ultimoOrderWebOfertas = await apiNavisionNew.navisionControllerGetendPoint('salesQuoteHeader', $filter, $top, undefined, $orderby, undefined, undefined).then((response) => {
        const { data } = response
        const lastRecord = data?.value[0]; // Obtener el último registro
        return lastRecord?.orderWeb || `${prefix}${añoActualCorto}-000000`;
      })
      // Obtener el último registro de la tabla 'salesOrderHeader'
      const ultimoOrderWebPedidos = await apiNavisionNew.navisionControllerGetendPoint('salesOrderHeader', $filter, $top, undefined, $orderby, undefined, undefined).then((response) => {
        const { data } = response
        const lastRecord = data?.value[0]; // Obtener el último registro
        return lastRecord?.orderWeb || `${prefix}${añoActualCorto}-000000`;
      })
      // Obtener el número final de la oferta y del pedido
      const numeroFinalOfertas = ultimoOrderWebOfertas.split('-').pop();
      const numeroFinalOPedidos = ultimoOrderWebPedidos.split('-').pop();
      let nuevoNumero = 0;
      // Comprobar cuál es mayor y sumarle 1, esto se hace ya que las ofertas cuando se convierten en pedidos se borran, asi que el numero nunca avanza como tal y como se le asigna el mismo número al pedido si el pedido es mayor que la oferta entonces continua desde el pedido y viceversa
      if (parseInt(numeroFinalOfertas, 10) > parseInt(numeroFinalOPedidos, 10)) {
        nuevoNumero = parseInt(numeroFinalOfertas, 10) + 1;
      } else {
        nuevoNumero = parseInt(numeroFinalOPedidos, 10) + 1;
      }
      const nuevoNumeroFormateado = nuevoNumero.toString().padStart(numeroFinalOfertas.length, '0');
      const nuevoOrderWeb = `${prefix}-${añoActualCorto}-${nuevoNumeroFormateado}`;
      return nuevoOrderWeb;
    } catch (error) {
      // Manejar los errores
      console.error('Error fetching companies for products:', error);
      throw error;
  }
}

// ** Crea/edita oferta
export const createNewSalesOrder = (yourReference, date, programado, especial, depositoOrder, tipoDeDelivery, codigoDeAgenteDeEnvío, codigoDeServicioDelAgenteDeEnvío, porte, volumen, intl) => {
  return async (dispatch, getState) => {
    try {
      //getPrecioPortes(countryCode, regionCode, unitPrice)
      const store = getState().ecommerce
      const storeAdmin = getState().admin.users
      // Recojo tipo y codigo, codVendedor(si es vendedor) y selecciono uno u otro dependiendo del caso
      let tipoUsuario, codigoCliente, codVendedor
      if (storeAdmin.selectedUser.tipoUsuario === "V") {
        tipoUsuario = "B2B_Comercial"
        codigoCliente = storeAdmin.clienteSelected
        codVendedor = storeAdmin.selectedUser.codVendedorCliente
      } else {
        tipoUsuario = "B2B_Cliente"
        codigoCliente = storeAdmin.selectedUser.codVendedorCliente
        const codigoVendedor = await getCodVendedor(codigoCliente)
        codVendedor = codigoVendedor[0].code
      }
      const { cart, shippingAddress, newShipToCode } = store
      if (storeAdmin.selectedUser.companyId !== 43) {
        const lineas = cart.map(cartItem => {
          const tieneNuevoPrecio = cartItem.nuevoPrecioAumentado !== null && cartItem.nuevoPrecioAumentado !== undefined && cartItem.nuevoPrecioAumentado !== '';
          const precioFinal = tieneNuevoPrecio ? cartItem.nuevoPrecioAumentado : (cartItem.PVC_OriginalBC || '0.00');
          return {
            no: cartItem.model,
            quantity: cartItem.qty,
            unitPrice: precioFinal.toString(),
            discountLine: cartItem.CustomerSalesDiscount || 0,
            totalVolume: cartItem.volumen || 0,
            ItemClub: cartItem?.rangoNombre || ''
          }
        })
        let shipCode = shippingAddress.shipToCode == undefined ? newShipToCode : shippingAddress.shipToCode
        const volumenValue = (volumen == undefined || volumen == null) ? 0 : volumen
        let tarifa = ''
        if (localStorage.getItem('tarifaDefecto').indexOf('Selec') < 0) {
          tarifa = localStorage.getItem('tarifaDefecto')
        }
        
        // Crea el elemento 'shipmentMethod' y le asigna un valor, en función de si es 'Recogida en tienda' o no
        let metodoDeEnvio = '' // Valor por defecto
        if (store.shippingAddress.name == "" && store.shippingAddress.address == "" && porte === 0) {  // Comprueba si el nombre y la dirección están vacíos, además de si los portes son 0, que es el caso 'Recogida en tienda'
          metodoDeEnvio = "RTIRCTE"  // Valor que se envía a BC para indicar que es 'Recogida en tienda'
          shipCode = "" // Es un valor que se obtiene de la dirección de envío, como no hay porque es 'Recogida en tienda' he puesto "", si no, devolvería null causando un error
        }
        let newSalesOrder = ""
        if (localStorage.getItem("carritoRepuestos") === 'true') {
          newSalesOrder = {
            deliveryType: tipoDeDelivery,
            // shippingAgentCode: codigoDeAgenteDeEnvío, // NO SE ENVIAN CUANDO ES COMPRA DE REPUESTOS
            // shippingAgentServiceCode: codigoDeServicioDelAgenteDeEnvío, // NO SE ENVIAN CUANDO ES COMPRA DE REPUESTOS
            orderDate: (new Date).toISOString().slice(0, 10),
            sellToCustomerNo: codigoCliente,
            requestDeliveryDate: date,
            salesPerson: codVendedor,
            especialOrder: especial,
            programedOrder: programado,
            shipToCode: shipCode,
            yourReference,
            lines: lineas,
            depositOrder: depositoOrder,
            isRepair: true,
            fromSAT: false,
            sourceOrder: tipoUsuario,
            portes: 0, // CUANDO ES REPUESTOS NO SE COBRAN PORTES
            volumen: volumenValue,
            customerPriceGroup: tarifa,
            shipmentMethod: metodoDeEnvio  // Valor que indica el método de envío y evalúa si es 'Recogida en tienda'
          }
        } else {
          newSalesOrder = {
            deliveryType: tipoDeDelivery,
            shippingAgentCode: codigoDeAgenteDeEnvío,
            shippingAgentServiceCode: codigoDeServicioDelAgenteDeEnvío,
            orderDate: (new Date).toISOString().slice(0, 10),
            sellToCustomerNo: codigoCliente,
            requestDeliveryDate: date,
            salesPerson: codVendedor,
            especialOrder: especial,
            programedOrder: programado,
            shipToCode: shipCode,
            yourReference,
            lines: lineas,
            depositOrder: depositoOrder,
            isRepair: false,
            fromSAT: false,
            sourceOrder: tipoUsuario,
            portes: porte,
            volumen: volumenValue,
            customerPriceGroup: tarifa,
            shipmentMethod: metodoDeEnvio  // Valor que indica el método de envío y evalúa si es 'Recogida en tienda'
          }
        }
        const code = newSalesOrder.sellToCustomerNo
        // Si existe es que se está editando una oferta existente
        if (store.salesQuoteIdentifier) newSalesOrder = { ...newSalesOrder, orderNo: store.salesQuoteIdentifier }
        displayInfoMsg(intl.formatMessage({ id:"Process initiated"}))
        const objJSON = JSON.stringify(newSalesOrder) // <-- creamos el JSON a enviar
        const { data } = await apiNavisionNew.navisionControllerPostEndpointBC("TW_Functions_InsertSalesOrder", objJSON)
        if (data?.mensaje?.message) {
          return displayErrorMsg(data?.mensaje.message) // Si hay error en la respuesta de Navision, muestra mensaje de error
        }
        // Éxito en la creación
        if (data.status == 'OK') {
          //Envio de notificación
          const oferta = JSON.parse(data.mensaje).message.replace("OK, Order ", "").replace(" has been created", "")
          // const { code } = getUserData()
          await axios.post(`${devuelveBasePath()}/notificaciones?codigoNotificacion=1&noDocumento=${oferta}&codigoCliente=${code}`)
          //
          //Mostramos el mensaje de Oferta insertada o modificada dependiendo de lo que estemos haciendo
          //
          let respuesta
          if (store.salesQuoteIdentifier) {
            respuesta = `${intl.formatMessage({ id:' Sales Quote'})} ${store.salesQuoteIdentifier} ${intl.formatMessage({ id: 'successfully modified'})}. `
          } else {
            respuesta = `${intl.formatMessage({ id: 'The offer was generated'})} ${oferta} ${intl.formatMessage({ id: 'successfully'})}`
          }

          dispatch(clearCart())
          dispatch({ type: `${prefix}/CLEAR_SHIPPING_ADDRESS` })
          dispatch(clearSalesQuoteCart())

          return {respuesta, oferta}
        }
        //
        //Si ha ocurrido algún problema mostramos el error
        //
        if (data.mensaje.message) { 
          let texto = ""
          const mensaje = data.mensaje.message
          if (mensaje.includes('You cannot create this type of document when') || mensaje.includes('No puede crear este tipo de documento cuando')) {
            texto = intl.formatMessage({ id: "Customer blocked, contact administration."}) // aqui es el otro mensaje que hay que cambiar el mensaje del include que compruebe si es en castellano 
          }
          if (texto != '') {
            return displayErrorMsg(texto)
          } else {
            return displayErrorMsg(data.mensaje.message)
          }
        }
      } else {
        let companies = [];
        let listaSlugs = [];
        const results = [];
        await fetchCompaniesForProducts(cart, localStorage.getItem('clienteDefecto').split(' ')[0]).then(allCompaniesData => {
          companies = Object.keys(allCompaniesData);
          companies.forEach((element, index) => {
            console.log('Elemento:', element);
            listaSlugs = allCompaniesData[element].map(item => item.slug);
            results.push({
              [element]: listaSlugs
            });
          });
        }).catch(error => {
          console.error('Error en la llamada a fetchCompaniesForProducts:', error);
        }); 
        const respuestas = [];
        const orderWEBId = await crearOrderWebId('PW')
        let orderWebExistente = '';
        let lineas = [];
        for (let empresas = 0; empresas < companies.length; empresas++) {  
          const todosLosProductos = []; // Inicializar un array vacío para almacenar todos los productos
          for (let producto = 0; producto < results[empresas][companies[empresas]].length; producto++) {
            lineas = cart
              .filter(cartItem => cartItem.model === results[empresas][companies[empresas]][producto])
              .map(cartItem => {
                const tieneNuevoPrecio = cartItem.nuevoPrecioAumentado !== null && cartItem.nuevoPrecioAumentado !== undefined && cartItem.nuevoPrecioAumentado !== '';
                const precioFinal = tieneNuevoPrecio ? cartItem.nuevoPrecioAumentado : (cartItem.PVC_OriginalBC || '0.00');
                return {
                  no: cartItem.model,
                  quantity: cartItem.qty,
                  unitPrice: precioFinal.toString(),
                  discountLine: cartItem.CustomerSalesDiscount || 0,
                  totalVolume: cartItem.volumen || 0,
                  ItemClub: cartItem?.rangoNombre || ''
                };
              });
          
            todosLosProductos.push(lineas);
          }
          const productosPlanos = todosLosProductos.flat(); // Convertir el array de arrays en un array plano
          let shipCode = shippingAddress.shipToCode == undefined ? newShipToCode : shippingAddress.shipToCode
          const volumenValue = (volumen == undefined || volumen == null) ? 0 : volumen
          let tarifa = ''
          if (localStorage.getItem('tarifaDefecto').indexOf('Selec') < 0) {
            tarifa = localStorage.getItem('tarifaDefecto')
          }
          
          // Crea el elemento 'shipmentMethod' y le asigna un valor, en función de si es 'Recogida en tienda' o no
          let metodoDeEnvio = '' // Valor por defecto
          if (store.shippingAddress.name == "" && store.shippingAddress.address == "" && porte === 0) {  // Comprueba si el nombre y la dirección están vacíos, además de si los portes son 0, que es el caso 'Recogida en tienda'
            metodoDeEnvio = "RTIRCTE"  // Valor que se envía a BC para indicar que es 'Recogida en tienda'
            shipCode = "" // Es un valor que se obtiene de la dirección de envío, como no hay porque es 'Recogida en tienda' he puesto "", si no, devolvería null causando un error
          }
          let newSalesOrder = ""
          let portesDefinitivo = 0;
          const existsSVAN = companies.some(company => company.includes('SVAN TRADING S.L.'));
          if (existsSVAN) {
            if (companies[empresas].includes('SVAN TRADING S.L.')) {
              portesDefinitivo = porte
            }
          } else if (!existsSVAN && empresas === 0) {
            portesDefinitivo = porte
          }
          if (localStorage.getItem("carritoRepuestos") === 'true') {
            newSalesOrder = {
              deliveryType: tipoDeDelivery,
              // shippingAgentCode: codigoDeAgenteDeEnvío, // NO SE ENVIAN CUANDO ES COMPRA DE REPUESTOS
              // shippingAgentServiceCode: codigoDeServicioDelAgenteDeEnvío, // NO SE ENVIAN CUANDO ES COMPRA DE REPUESTOS
              orderDate: (new Date).toISOString().slice(0, 10),
              sellToCustomerNo: codigoCliente,
              requestDeliveryDate: date,
              salesPerson: codVendedor,
              especialOrder: especial,
              programedOrder: programado,
              shipToCode: shipCode,
              yourReference,
              lines: productosPlanos,
              depositOrder: depositoOrder,
              isRepair: true,
              fromSAT: false,
              sourceOrder: tipoUsuario,
              portes: 0, // CUANDO ES REPUESTOS NO SE COBRAN PORTES
              volumen: volumenValue,
              customerPriceGroup: tarifa,
              shipmentMethod: metodoDeEnvio,  // Valor que indica el método de envío y evalúa si es 'Recogida en tienda'
              orderWeb: orderWEBId,
              pEmpresa: companies[empresas]
            }
          } else {
            newSalesOrder = {
              deliveryType: tipoDeDelivery,
              shippingAgentCode: codigoDeAgenteDeEnvío,
              shippingAgentServiceCode: codigoDeServicioDelAgenteDeEnvío,
              orderDate: (new Date).toISOString().slice(0, 10),
              sellToCustomerNo: codigoCliente,
              requestDeliveryDate: date,
              salesPerson: codVendedor,
              especialOrder: especial,
              programedOrder: programado,
              shipToCode: shipCode,
              yourReference,
              lines: productosPlanos,
              depositOrder: depositoOrder,
              isRepair: false,
              fromSAT: false,
              sourceOrder: tipoUsuario,
              portes: portesDefinitivo,
              volumen: volumenValue,
              customerPriceGroup: '',
              shipmentMethod: metodoDeEnvio,  // Valor que indica el método de envío y evalúa si es 'Recogida en tienda'
              orderWeb: orderWEBId,
              pEmpresa: companies[empresas]
            }
          }
          const code = newSalesOrder.sellToCustomerNo
          // Si existe es que se está editando una oferta existente
          if (store.salesQuoteIdentifier) { 
            const splitIdentifier = store.salesQuoteIdentifier.split('-');
            const $expand = 'salesQuoteLines';
            if (splitIdentifier[empresas]) {
              for (const codigoOferta of splitIdentifier) {
                const identificadorOferta = await apiNavisionNew.navisionControllerGetendPoint('salesQuoteHeader', `documentNo eq '${codigoOferta}'`, undefined, undefined, undefined, $expand, undefined).then((response) => {
                  
                  orderWebExistente = response.data.value[0].orderWeb;
                  return response.data.value[0].documentNo;

                });
                // Si no cumple la condición, continuar a la siguiente iteración
                if (identificadorOferta === '') {
                  continue;
                }
                console.log('Identificador de oferta:', identificadorOferta);
                newSalesOrder = { ...newSalesOrder, orderNo: identificadorOferta, orderWeb: orderWebExistente }    
                break; // Salir del bucle si se encontró una oferta válida
              }
            } else {
              newSalesOrder = { ...newSalesOrder, orderWeb: orderWebExistente }
            }
          }
          displayInfoMsg(intl.formatMessage({ id:"Process initiated"}))
          const objJSON = JSON.stringify(newSalesOrder) // <-- creamos el JSON a enviar
          const { data } = await apiNavisionNew.navisionControllerPostEndpointBC("TW_Functions_InsertSalesOrder", objJSON)
          if (data?.mensaje?.message) {
            return displayErrorMsg(data?.mensaje.message) // Si hay error en la respuesta de Navision, muestra mensaje de error
          }
          // Éxito en la creación
          let respuesta
          if (data.status == 'OK') {
            //Envio de notificación
            const oferta = JSON.parse(data.mensaje).message.replace("OK, Order ", "").replace(" has been created", "")
            const { code } = getUserData()
            await axios.post(`${devuelveBasePath()}/notificaciones?codigoNotificacion=1&noDocumento=${oferta}&codigoCliente=${code}`)
            //
            //Mostramos el mensaje de Oferta insertada o modificada dependiendo de lo que estemos haciendo
            //
            if (store.salesQuoteIdentifier) {
              const splitIdentifier = store.salesQuoteIdentifier.split('-');
              if (splitIdentifier[empresas]) {
                respuesta = `${intl.formatMessage({ id:' Sales Quote'})} ${splitIdentifier[empresas]} ${intl.formatMessage({ id: 'successfully modified'})}. `
              } else {
                respuesta = `${intl.formatMessage({ id: 'The offer was generated'})} ${oferta} ${intl.formatMessage({ id: 'successfully'})}`
              }
            } else {
              respuesta = `${intl.formatMessage({ id: 'The offer was generated'})} ${oferta} ${intl.formatMessage({ id: 'successfully'})}`
            }  
            respuestas.push({ respuesta, oferta });
          }
          //
          //Si ha ocurrido algún problema mostramos el error
          //
          if (data.mensaje.message) { 
            const mensaje = data.mensaje.message
            if (mensaje.includes('You cannot create this type of document when') || mensaje.includes('No puede crear este tipo de documento cuando')) {
              respuesta = intl.formatMessage({ id: "Customer blocked, contact administration."}) // aqui es el otro mensaje que hay que cambiar el mensaje del include que compruebe si es en castellano 
            }
            if (respuesta != '') {
              respuestas.push({respuesta });
            } else {
              respuestas.push({respuesta });
            }
          }
        }
        // Procesar las respuestas almacenadas
        dispatch(clearCart())
        dispatch({ type: `${prefix}/CLEAR_SHIPPING_ADDRESS` })
        dispatch(clearSalesQuoteCart())
        return respuestas;
      }
    } catch (err) {
      displayErrorMsg(err)
    }
  }
}

// ** Crea/edita oferta
export const editarReferenciaYDireccionSalesOrder = (nuevaReferencia, nuevaDireccion, store, intl) => {
  return async (dispatch, getState) => {
    try {
      const storeAdmin = getState().admin.users
      const respuestas = [];
      // Recojo tipo y codigo, codVendedor(si es vendedor) y selecciono uno u otro dependiendo del caso
      let tipoUsuario
      if (storeAdmin.selectedUser.tipoUsuario === "V") {
        tipoUsuario = "B2B_Comercial"
      } else {
        tipoUsuario = "B2B_Cliente"
      }
      const productsArr = store.salesQuoteLines.map((line) => {
        return {no: line.no, quantity: line.quantity, discountLine: line.lineDiscountPercent, totalVolume:line.totalVolume, unitPrice:line.unitPrice}
      })
      let newSalesOrder = ""
      if (storeAdmin.selectedUser.companyId !== 43) {
        if (store.salesQuoteLines[0].itemCategoryCode === 'REPUESTOS') {
          newSalesOrder = {
            orderNo: store.documentNo,
            orderDate: store.orderDate,
            sellToCustomerNo: store.sellToCustomerNo,
            requestDeliveryDate: store.requestedDeliveryDate,
            salesPerson: store.salespersonCode,
            especialOrder: store.specialOrder,
            programedOrder: store.programedOrder,
            shipToCode: nuevaDireccion.shipToCode,
            yourReference: nuevaReferencia,
            lines: productsArr,
            depositOrder: store.depositOrder,
            isRepair: true,
            fromSAT: false,
            sourceOrder: tipoUsuario,
            portes: 0, // CUANDO ES REPUESTOS NO SE COBRAN PORTES
            volumen: store.volumen,
            customerPriceGroup: store.customerPriceGroup,
            shipmentMethod: ''
          }
        } else {
          newSalesOrder = {
            orderNo: store.documentNo,
            orderDate: store.orderDate,
            sellToCustomerNo: store.sellToCustomerNo,
            requestDeliveryDate: store.requestedDeliveryDate,
            salesPerson: store.salespersonCode,
            especialOrder: store.specialOrder,
            programedOrder: store.programedOrder,
            shipToCode: nuevaDireccion.shipToCode,
            yourReference: nuevaReferencia,
            lines: productsArr,
            depositOrder: store.depositOrder,
            isRepair: false,
            fromSAT: false,
            sourceOrder: tipoUsuario,
            portes: store.postes,
            volumen: store.volumen,
            customerPriceGroup: store.customerPriceGroup,
            shipmentMethod: ''
          }
        }
        const code = newSalesOrder.sellToCustomerNo
        displayInfoMsg(intl.formatMessage({ id:"Process initiated"}))
        const objJSON = JSON.stringify(newSalesOrder) // <-- creamos el JSON a enviar
        const { data } = await apiNavisionNew.navisionControllerPostEndpointBC("TW_Functions_InsertSalesOrder", objJSON)
        if (data?.mensaje?.message) {
          return displayErrorMsg(data?.mensaje.message) // Si hay error en la respuesta de Navision, muestra mensaje de error
        }
        // Éxito en la creación
        if (data.status == 'OK') {
          //Envio de notificación
          const oferta = JSON.parse(data.mensaje).message.replace("OK, Order ", "").replace(" has been created", "")
          // const { code } = getUserData()
          await axios.post(`${devuelveBasePath()}/notificaciones?codigoNotificacion=1&noDocumento=${oferta}&codigoCliente=${code}`)
          //
          //Mostramos el mensaje de Oferta insertada o modificada dependiendo de lo que estemos haciendo
          //
          let respuesta
          if (store.salesQuoteIdentifier) {
            respuesta = `${intl.formatMessage({ id:' Sales Quote'})} ${store.salesQuoteIdentifier} ${intl.formatMessage({ id: 'successfully modified'})}. `
          } else {
            respuesta = `${intl.formatMessage({ id: 'The offer was generated'})} ${oferta} ${intl.formatMessage({ id: 'successfully'})}`
          }

          return {respuesta, oferta}
        }
        //
        //Si ha ocurrido algún problema mostramos el error
        //
        if (data.mensaje.message) { 
          let texto = ""
          const mensaje = data.mensaje.message
          if (mensaje.includes('You cannot create this type of document when') || mensaje.includes('No puede crear este tipo de documento cuando')) {
            texto = intl.formatMessage({ id: "Customer blocked, contact administration."}) // aqui es el otro mensaje que hay que cambiar el mensaje del include que compruebe si es en castellano 
          }
          if (texto != '') {
            return displayErrorMsg(texto)
          } else {
            return displayErrorMsg(data.mensaje.message)
          }
        }
      } else {
        let $filterOrderWeb = ``

        if (store.orderWeb === '') {
          $filterOrderWeb = `documentNo eq '*${store.documentNo}*'`
        } else {
          $filterOrderWeb = `orderWeb eq '*${store.orderWeb}*'`
        }
        const datosOfertas = await apiNavisionNew.navisionControllerGetendPoint('salesQuoteHeader', $filterOrderWeb, undefined, undefined, undefined, 'salesQuoteLines', undefined)

        if (datosOfertas.data?.mensaje?.message) {
          return displayErrorMsg(datosOfertas.data.mensaje.message) // Si hay error en la respuesta de Navision, muestra mensaje de error
        }

        for (const oferta of datosOfertas.data.value) {
          const empresa = await apiNavisionNew.navisionControllerGetEmpresaPorIdDato(oferta.documentNo, 'documentNo', 'salesQuoteHeader', oferta.billtoCustomerNo)
          let newSalesOrder;
            // Eliminar la propiedad @odata.etag de cada línea en salesQuoteLines
          oferta.salesQuoteLines = oferta.salesQuoteLines.map(line => {
            const { ['@odata.etag']: _, ...rest } = line;
            return rest;
          });
          const productsArr = oferta.salesQuoteLines.map((line) => {
            return {no: line.no, quantity: line.quantity, discountLine: line.lineDiscountPercent, totalVolume:line.totalVolume, unitPrice:line.unitPrice}
          })
          if (oferta.salesQuoteLines[0].itemCategoryCode === 'REPUESTOS') {
            newSalesOrder = {
              orderNo: oferta.documentNo,
              orderDate: oferta.orderDate,
              sellToCustomerNo: oferta.sellToCustomerNo,
              requestDeliveryDate: oferta.requestedDeliveryDate,
              salesPerson: oferta.salespersonCode,
              especialOrder: oferta.specialOrder,
              programedOrder: oferta.programedOrder,
              shipToCode: nuevaDireccion.shipToCode,
              yourReference: nuevaReferencia,
              lines: productsArr,
              depositOrder: oferta.depositOrder,
              isRepair: true,
              fromSAT: false,
              sourceOrder: tipoUsuario,
              portes: 0, // CUANDO ES REPUESTOS NO SE COBRAN PORTES
              volumen: oferta.volumen,
              customerPriceGroup: oferta.customerPriceGroup,
              shipmentMethod: '',
              orderWeb: oferta.orderWeb,
              companyId: empresa.data.companyId
            };
          } else {
            newSalesOrder = {
              orderNo: oferta.documentNo,
              orderDate: oferta.orderDate,
              sellToCustomerNo: oferta.sellToCustomerNo,
              requestDeliveryDate: oferta.requestedDeliveryDate,
              salesPerson: oferta.salespersonCode,
              especialOrder: oferta.specialOrder,
              programedOrder: oferta.programedOrder,
              shipToCode: nuevaDireccion.shipToCode,
              yourReference: nuevaReferencia,
              lines: productsArr,
              depositOrder: oferta.depositOrder,
              isRepair: false,
              fromSAT: false,
              sourceOrder: tipoUsuario,
              portes: oferta.postes,
              volumen: oferta.volumen,
              customerPriceGroup: oferta.customerPriceGroup,
              shipmentMethod: '',
              orderWeb: oferta.orderWeb,
              companyId: empresa.data.companyId
            };
          }
          
          displayInfoMsg(intl.formatMessage({ id: "Process initiated" }));
          const objJSON = JSON.stringify(newSalesOrder); // <-- creamos el JSON a enviar
          const { data } = await apiNavisionNew.navisionControllerPostEndpointBC("TW_Functions_InsertSalesOrder", objJSON);
          if (data?.mensaje?.message) {
            return displayErrorMsg(data?.mensaje.message) // Si hay error en la respuesta de Navision, muestra mensaje de error
          }
        
          // Éxito en la creación
          let respuesta;
          if (data.status == 'OK') {
            // Envio de notificación
            const oferta = JSON.parse(data.mensaje).message.replace("OK, Order ", "").replace(" has been created", "");
            const { code } = getUserData();
            await axios.post(`${devuelveBasePath()}/notificaciones?codigoNotificacion=1&noDocumento=${oferta}&codigoCliente=${code}`);
        
            // Mostramos el mensaje de Oferta insertada o modificada dependiendo de lo que estemos haciendo
            if (store.salesQuoteIdentifier) {
              respuesta = `${intl.formatMessage({ id: 'Sales Quote' })} ${store.salesQuoteIdentifier} ${intl.formatMessage({ id: 'successfully modified' })}. `;
            } else {
              respuesta = `${intl.formatMessage({ id: 'The offer was generated' })} ${oferta} ${intl.formatMessage({ id: 'successfully' })}`;
            }
        
            respuestas.push({ respuesta, oferta });
          }
        
          // Si ha ocurrido algún problema mostramos el error
          if (data.mensaje.message) {
            respuesta = data.mensaje.message;
            if (respuesta.includes('You cannot create this type of document when') || respuesta.includes('No puede crear este tipo de documento cuando')) {
              respuesta = intl.formatMessage({ id: "Customer blocked, contact administration." }); // aqui es el otro mensaje que hay que cambiar el mensaje del include que compruebe si es en castellano 
            }
            if (respuesta != '') {
              respuestas.push({ respuesta });
            } else {
              respuestas.push({ respuesta });
            }
          }
        }
        return respuestas;
      }
    } catch (err) {
      displayErrorMsg(err)
    }
  }
}


// ** Set filtros aplicados a la tienda
export const setFilters = (searchFilters) => {
  return (dispatch) => {
    return dispatch({ type: `${prefix}/SET_FILTERS`, data: searchFilters })
  }
}

// ** CLEAR filtros aplicados a la tienda
export const clearFilters = () => {
  return (dispatch) => {
    return dispatch({ type: `${prefix}/CLEAR_FILTERS` })
  }
}

// ** Set productos filtrados
export const setFilteredProducts = (products, setCargandoCursor) => {
  return async (dispatch) => {
    dispatch({ type: `${prefix}/SET_PRODUCTS`, data: products })
    if (localStorage.getItem('noEjecutar') === 'SI') {
      setCargandoCursor(true)
      // return await dispatch(refreshDisplayedProducts())
      await dispatch(getProducts({ page: 1, tarifa: localStorage.getItem('tarifaDefecto'), code: localStorage.getItem('clienteDefecto').split(' ')[0]}))
      setCargandoCursor(false)
      return ''
    } else {
      return 'no hagas nada'
    }
  }
}

// ** Filtro direcciones envio
export const setAdressTypeFilter = (value) => {
  return dispatch => {
    return dispatch({ type: `${prefix}/ADRESS_TYPE_SHOP`, data: value })
  }
}

// ** Filtro direcciones envio
export const setNewAdressActive = (value) => {
  return dispatch => {
    if (value === true) dispatch({ type: `${prefix}/CLEAR_SHIPPING_ADDRESS` })
    return dispatch({ type: `${prefix}/NEW_ADRESS_ACTIVE`, data: value })
  }
}

// ** Vacía los datos de la dirección de envío 'shippingAddress'
export const resetAddressData = () => {
  return dispatch => {
    return dispatch({ type: `${prefix}/CLEAR_SHIPPING_ADDRESS` })
  }
}

export const getProductoNavFiltrado = (tarifa, precios, stock, code, selectedBrands, productos, intl) => {
  return async (dispatch, getState) => {
    try {
      //
      //Definimos las variables y mostramos un mensaje de que empieza el proceso
      //
      if (tarifa == undefined || tarifa ==  "") { tarifa = "" }
      const defecto = (precios.min == 0 && precios.max == 9999 && !stock) 
      // Definimos una función para cerrar el mensaje de Swal
      const closeSwal = () => {
        Swal.close();
      };
      Swal.fire({
        position: 'center',
        icon: 'info',
        showCloseButton: false,
        showConfirmButton: false,
        timerProgressBar: true,
        title: intl.formatMessage({ id: 'We are looking for the products...'}),
        didClose: closeSwal,
        timer: 3000, // Duración en milisegundos
        onBeforeOpen: () => {
          Swal.showLoading(); // Muestra la barra de progreso
        }
      })
      //
      //Obtenemos el filtro de marcas que puede ver el cliente con un await para que le de tiempo a hacer la consulta a la bbdd
      //
      const filtroMarca = (await Promise.all(selectedBrands.map(marca => getCodigoMarca(marca)))).join('|')

      const objNew = { 
        pCustomer: code,
        pcustomerPriceGroup: tarifa,
        pItem: "",
        pMarcas: filtroMarca,
        pOnlyStock: stock,
        pImpMinmo : parseFloat(precios.min),
        pImpMaximo: parseFloat(precios.max)
      }
      const objJSON = JSON.stringify(objNew)
      //
      //Hacemos una llamada a Nav con los filtros para que nos devuelva los que podemos mostrar según los filtros
      //
      await apiNavisionNew.navisionControllerPostEndpointBC('TW_Functions_GetItemListFiltered', objJSON).then((response) => {
        closeSwal()
        if (response?.data?.mensaje?.message) {
          return displayErrorMsg(response.data.mensaje.message) // Si hay error en la respuesta de Navision, muestra mensaje de error
        }
        const { data } = response
        if (data.status == 'OK') {
          const productosDevueltos = data.mensaje.split('|')
          const productosFiltrados = productos.filter(producto => productosDevueltos.includes(producto.name));
          console.log(productosFiltrados)
          dispatch(setFilteredProducts(productosFiltrados)) 
        }
        //
        //Si ha ocurrido algún problema mostramos el error
        //
        if (data.mensaje.message) { 
          return displayErrorMsg(data.mensaje.message)
        }
      })
      
    } catch (err) {
      displayErrorMsg(err)
    }
  }
}

// ** Fetch pdf y lo envia por correo
export const sendDeliveryNoteEmail = (mailObject, intl) => {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  return async (dispatch) => {
    try {
      Swal.fire({
        position: 'center',
        title: intl.formatMessage({ id: 'Process started on the server, a warning will be displayed on the screen at the end of the process.'}),
        icon: 'info'
      })
      await apiMail.mailControllerSendMail(mailObject).then((response) => {
        setTimeout(() =>  {
          const navpills = document.querySelectorAll('.nav-pills')
          const navItems = navpills[0].childNodes
          navItems.forEach(el => {
            el.firstChild.style = ""
          })
        }, 500)
        dispatch({
          type: SEND_DELIVERY_NOTE
        })
        odataLogs(response.config.url, response.status, response.config.method, SEND_DELIVERY_NOTE, config)
      }).catch((err) => odataLogs(err.message, "ERROR", "", SEND_DELIVERY_NOTE, config))
      Swal.fire({
        position: 'center',
        icon: 'success',
        title: intl.formatMessage({ id: 'E-mail sent'})
      })
    } catch (err) {
      console.error(err.message)
    }
  }

}

export const getRepuestosBC = (nombreProducto) => {
  return async () => {
      const select = "";
      const filter = `?$filter=parentItemNo eq '${nombreProducto}'`;
      const orderBy = "";
      const top = "";
      return await apiSat.conexionSatControllerGetRepuestosBC("repuestos", select, filter, orderBy, top)
  }
}